/**
 * helpContent.js — ХУУДАС БҮРИЙН ЗААВАРЧИЛГАА.
 *
 * ⚠ ЯАГААД НЭГ ФАЙЛД ТӨВЛӨРҮҮЛЭВ:
 *   Заавар нь хугацаа өнгөрөх тусам хамгийн их засагддаг агуулга — журам
 *   шинэчлэгдэх, алхам нэмэгдэх бүрд. Хуудас бүрийн код дотор тарж бичвэл
 *   тэдгээрийг хайж олоход төвөгтэй, зарим нь мартагдаж хуучирдаг. Энд нэг
 *   дор байснаар ХАБЭА хэлтсийн хүн ч гэсэн шууд олж уншиж чадна.
 *
 * Бүтэц:
 *   key: {
 *     title:  цонхны гарчиг
 *     intro:  нэг өгүүлбэрээр — энэ хуудас юуны төлөө вэ
 *     steps:  [{ title, text }]   — юуг ямар дарааллаар хийх
 *     notes:  ["..."]             — анхаарах зүйл (заавал биш)
 *     rule:   "ХЭМАБМТ-... 4.3.5" — журмын эх сурвалж (заавал биш)
 *   }
 *
 * Түлхүүрийг ЗАМААР нэрлэв (`risk/dashboard`) — шинэ хуудас нэмэхэд
 * хаанаас хайхаа мэдэхэд хялбар.
 */

/* ХЯНАЛТ ШАЛГАЛТЫН ЖАГСААЛТ — /inspection/register · /inspection/xab ·
   /inspection/list/20. Гурван зам НЭГ жагсаалтын хуудас (pages/
   inspection/xab/list.js) тул заавар нь НЭГ объект бөгөөд доор гурван
   түлхүүрт хуваарилагдана.
   ⚠ `/inspection/register` нь БҮРТГЭХ маягт БИШ, ЖАГСААЛТ харуулдаг.
     Тэр хуудас тусламжийн түлхүүрээ ЗАМААСАА уншдаг тул
     `inspection/register` нь ЖАГСААЛТЫН заавар байх ёстой — урьд нь
     «Хяналт шалгалт БҮРТГЭХ» гарч, жагсаалтын хуудсанд бөглөх
     зааварчилгаа харагддаг байв (2026-10-01). Бүртгэх зааврыг бөглөх
     модуль ӨӨРӨӨ авна: `inspection/fill`. */
const INSPECTION_LIST = {
    title: "Хяналт шалгалтын жагсаалт",
    intro:
      "Хийгдсэн бүх шалгалт, тэдгээрээр илэрсэн зөрчил, биелэлтийг нэг " +
      "дор харах хуудас. Шинэ шалгалт мөн эндээс эхлүүлнэ.",
    steps: [
      {
        title: "Хураангуй тоонуудаас уншиж эхэл",
        text:
          "Хүснэгтийн дээд талын картууд: нийт шалгалт, нээлттэй, " +
          "хаагдсан, хугацаа хэтэрсэн. Карт дээр дарвал тухайн төлөвөөр " +
          "шүүгдэнэ — дахин дарвал шүүлт арилна.",
      },
      {
        title: "Шүүлтээ тавь",
        text:
          "Шат, бүтцийн нэгж, хэсэг, огнооны хязгаар, төлөв. Шүүлт " +
          "хуудсыг дахин нээхэд ч хадгалагдана.",
      },
      {
        title: "Групплэсэн мөрийн тоог уншиж сур",
        text:
          "Бүтцийн нэгжийн мөрийн ард «Нийт: 6, I шат: 2, II шат: 5» гэж " +
          "тухайн нэгжийн шалгалтыг шатаар харуулна. Мөр дээр дарвал " +
          "нэгжийн шалгалтууд дэлгэгдэнэ.",
      },
      {
        title: "«Илэрсэн зөрчил» баганыг зөв уншина",
        text:
          "«24 / 18 / 3» гэсэн тоо нь: шалгах хуудсан дээрх НИЙТ " +
          "үзүүлэлт / бөглөсөн / тэднээс зөрчилтэй гэсэн дараалал. " +
          "Доорх «5 бөглөөгүй» гэсэн шар мөр нь бөглөж дуусгаагүйг " +
          "сануулна. Зөрчлийн тоо тод улаанаар онцлогдоно.",
      },
      {
        title: "Хэсэг, байршлыг зураасан дээр харах",
        text:
          "Байршлын мэдээлэл багананд багтахгүй тул зөвхөн тэмдэг " +
          "харагдана — хулганаа хүргэхэд бүтнээр уншигдана. Урт " +
          "зөрчлийн тайлбар ч мөн адил.",
      },
      {
        title: "Харах ба засах",
        text:
          "«Харах» нь бөглөсөн хуудсыг уншина, «Засах» нь бөглөх " +
          "хуудас руу оруулна. Засах товч нь ЗӨВХӨН эрхтэй хүнд " +
          "харагдана — өөрийн бус нэгжийн шалгалтыг засахгүй.",
      },
    ],
    notes: [
      "Хугацаа хэтэрсэн зөрчил улаанаар гарна — эдгээр нь дараагийн аудитад цоорхой болно.",
      "Зөрчлийн дүнг «хяналт шалгалтаар илэрсэн» ба «зөрчлөөр бүртгэгдсэн» гэж САЛГАЖ харуулна. Хоёрыг нэмж нэг тоо болгож болохгүй — эх сурвалж өөр.",
      "Хуучин системээс хөрвүүлсэн архивын бичлэгүүд «Ээлжит бус» гэж орсон. Тиймээс шинэ системээр хийсэн шалгалтыг тоолохдоо шатаар шүүж хар.",
    ],
    rule: "ХЭМАБМТ-06 · хяналт шалгалтын журам",
};

export const HELP = {
  // ── Ажил зогсоох эрх (SWA) ───────────────────────────────────────────
  "stopwork/register": {
    title: "Ажил зогсоох эрх",
    intro:
      "Ажилтан аюул илрүүлж ажлаа зогсоосны ДАРААХ шийдвэрлэлтийг хөтөлнө " +
      "— комисс ирсэн үү, аюул арилсан уу, ажилд гаргасан уу.",
    steps: [
      {
        title: "Зогсолт ЭНД үүсдэггүй",
        text:
          "Ажилтан 15 асуумж дээр «Тийм» гэж хариулахад зогсолт " +
          "АВТОМАТААР үүснэ. Энэ хуудас нь зөвхөн үргэлжлэлийг бүртгэнэ.",
      },
      {
        title: "Хүлээгдэж буйг эхэлж хар",
        text:
          "Улаанаар «хугацаа хэтэрсэн» гэж тэмдэглэгдсэн мөр нь ажилтан " +
          "талбар дээр ХҮЛЭЭЖ байна гэсэн үг — эхэлж түүнийг ав.",
      },
      {
        title: "Шатаа ахиул",
        text:
          "Зогсов → АШУА талбайд ирэв → АШУА зөвлөлдөв. Шийдэгдвэл " +
          "«Ажилд гаргах», эс бөгөөс ХАБЭА-д, дараа нь удирдлагад дамжина.",
      },
      {
        title: "Хийсэн ажлаа баримтжуул",
        text:
          "«Арга хэмжээ нэмэх» дээр юу хийсэн, хэн хийсэн, өмнөх/дараах " +
          "зургийг оруулна. Үүнгүйгээр «арилсан» гэдэг нь баримтгүй үг.",
      },
      {
        title: "Өөр хүнээр баталгаажуул",
        text:
          "Зөрчил бүрэн арилсныг ГҮЙЦЭТГЭГЧЭЭС ӨӨР хүн шалгаж " +
          "баталгаажуулна. Өөрийгөө шалгах нь хяналт биш.",
      },
    ],
    notes: [
      "ҮЛ БУРУУТГАХ ЗАРЧИМ — ажил зогсоосон ажилтныг буруутгахгүй. " +
        "Зогсоолт нь аюулаас урьдчилан сэргийлсэн ЭЕРЭГ үйлдэл.",
      "«Дамжуулах» болон «Бүрмөсөн зогсоох» үед шалтгаанаа заавал бичнэ.",
      "Талбар дээр гар утаснаас ажиллах нь илүү хялбар — «Талбайд ирэв» " +
        "дарахад байршил автоматаар бүртгэгдэнэ.",
    ],
  },

  // ── АШУА-гийн өдөр тутмын тайлан ─────────────────────────────────────
  "highrisk/ashuadaily": {
    title: "Өдөр тутмын тайлан",
    intro:
      "Анхан шатны удирдах ажилтны ХАБЭА өдөр тутмын 14 асуумж. Манай " +
      "бүртгэлээс гарах тоог автоматаар бөглөж, гараар оруулахыг л асууна.",
    steps: [
      {
        title: "Өөрийн нэгж шууд гарна",
        text:
          "Бүтцийн нэгж таны эрхээр анхдагчаар сонгогдоно. ХАБЭА хэлтэс " +
          "«Бүгд» болгож бүх цехийг харж болно.",
      },
      {
        title: "Хамрагдалтыг хар",
        text:
          "«Хэн тайлагнаагүй» хэсэг нь цехийн ХАБ-д зориулсан — хувь, " +
          "дутуу хүний жагсаалт. Нэр дээр дарж тайланг нь нээнэ.",
      },
      {
        title: "Зөвхөн 5 талбар бөглөнө",
        text:
          "«Өнөөдрийн тайлан бөглөх» дарахад 14-ийн оронд гараар оруулах " +
          "хэдхэн үзүүлэлт л ил гарна. Enter дарж дараагийн талбарт шилжинэ.",
      },
      {
        title: "Автомат тоог шалга",
        text:
          "«Манай бүртгэлээс автоматаар» хэсгийг дэлгэж, аюул, ӨЭА, " +
          "ХАБ-н минут зэрэг тоо зөв эсэхийг харна.",
      },
      {
        title: "Илгээх ба хэвлэх",
        text:
          "Илгээсний дараа тоо хөлдөнө. Засах бол «Ноорог болгох» дарж " +
          "буцаана. «Хэвлэх» нь албан маягтын хэлбэрээр A4-т гарна.",
      },
    ],
    notes: [
      "«Сараар (матриц)» горим — мөр нь өдөр, багана нь 14 асуумж. " +
        "Сарын тайланг бүтнээр нь харж, хэвлэнэ.",
      "«Зөрүү» багана нь манай систем тооцсоноос АШУА өөр тоо бичсэнийг " +
        "заана — тайлангийн чанарын хэмжүүр.",
      "Цехийн ХАБ нь ХЯНАГЧ — бусдын тайланг харна, хэвлэнэ, гэхдээ " +
        "бөглөхгүй, устгахгүй.",
    ],
    rule: "Анхан шатны удирдах ажилтны ХАБЭА өдөр тутмын тайлан — 14 асуумж",
  },

  // ── Эрсдэлийн удирдлага ──────────────────────────────────────────────
  "risk/dashboard": {
    title: "Эрсдэлийн хяналтын самбар",
    intro:
      "Байгууллагын эрсдэлийн ерөнхий зургийг харах, аль нэгж, ямар " +
      "төрлийн эрсдэл давамгайлж байгааг илрүүлэх хуудас.",
    steps: [
      {
        title: "Хамрах хүрээгээ сонго",
        text:
          "Дээд талын шүүлтээс цех, хэсэг, хугацааг сонгоно. Таны эрхээс " +
          "хамаарч зөвхөн харах эрхтэй нэгжүүд жагсаалтад гарна.",
      },
      {
        title: "Тоон үзүүлэлтийг унш",
        text:
          "Өндөр / Дунд / Бага гэсэн хуваарь нь эрсдэлийн матрицын оноогоор " +
          "тодорхойлогдоно: Бага 1-5, Дунд 6-19, Өндөр 20-25.",
      },
      {
        title: "Дэлгэрэнгүй рүү шилж",
        text:
          "Аль нэг тоо эсвэл нэгж дээр дарж тухайн бүлгийн жагсаалт руу " +
          "шилжинэ.",
      },
    ],
    notes: [
      "Энэ самбар нь зөвхөн ХАРАХ зориулалттай — үнэлгээ энд хийгдэхгүй.",
      "Тоо зөрж байвал эхлээд хугацааны шүүлтээ шалгана уу.",
    ],
    rule: "ХЭМАБМТ-05 · эрсдэлийн удирдлагын журам",
  },

  "risk/list": {
    title: "Эрсдэлийн жагсаалт",
    intro:
      "Бүртгэгдсэн бүх эрсдэлийг шүүж харах, шинэ үнэлгээ рүү шилжих " +
      "үндсэн ажлын хуудас.",
    steps: [
      {
        title: "Шүүж ол",
        text:
          "Цех, хэсэг, эрсдэлийн түвшин, төлөв, хугацаагаар шүүнэ. " +
          "Хайлтын талбарт эрсдэлийн нэр эсвэл кодыг бичиж болно.",
      },
      {
        title: "Мөрийн төлөвийг унш",
        text:
          "Өнгөт шошго нь эрсдэлийн түвшин, дүрс нь баталгаажилтын шатыг " +
          "заана — бүртгэсэн, БН баталсан, ЭҮХ хэлэлцсэн, удирдлага баталсан.",
      },
      {
        title: "Дэлгэрэнгүй нээ",
        text:
          "Мөр дээр дарж үнэлгээний дэлгэрэнгүй, хяналтын арга хэмжээ, " +
          "хариуцах эзэн, хугацааг харна.",
      },
    ],
    notes: [
      "Зөвхөн өөрийн эрхийн хүрээн дэх нэгжийн эрсдэл харагдана.",
    ],
  },

  "risk/assessment": {
    title: "Эрсдэлийн үнэлгээ хийх",
    intro:
      "Ажлын байр, үйл ажиллагаа бүрийн аюулыг тодорхойлж, магадлал ба " +
      "үр дагаврын огтлолцлоор эрсдэлийн оноог тогтоох маягт.",
    steps: [
      {
        title: "Ажлын байр, үйл ажиллагаагаа сонго",
        text: "Цех, хэсэг, ажлын байр, үнэлгээний чиглэлээ эхлээд тодорхойлно.",
      },
      {
        title: "Аюулыг тодорхойл",
        text:
          "Лавлахаас аюулын хүчин зүйлийг сонгоно. Нэг ажилд хэд хэдэн " +
          "хүчин зүйл хамаарч болно.",
      },
      {
        title: "Матрицаар үнэл",
        text:
          "Магадлал (1-5) ба үр дагаврыг (1-5) сонгоход систем матрицын " +
          "ОГТЛОЛЦЛООС оноог уншина. Энэ нь үржвэр БИШ — журмаар тогтоосон " +
          "хүснэгтийн утга.",
      },
      {
        title: "Хяналтын арга хэмжээ төлөвлө",
        text:
          "Оноо 6-аас дээш бол бууруулах арга хэмжээ, хариуцах эзэн, " +
          "хугацааг заавал бөглөнө.",
      },
    ],
    notes: [
      "⚠ Оноог гараар өөрчлөх боломжгүй — матрицаас автоматаар гарна.",
      "Үнэлгээ хадгалсны дараа БН-ийн даргад батлуулахаар илгээнэ.",
    ],
    rule: "ХЭМАБМТ-05 · 4.3.5, 4.3.6 — эрсдэлийн матриц",
  },

  "risk/tier1": {
    title: "1 дүгээр түвшний эрсдэл",
    intro:
      "Бүтцийн нэгжийн түвшинд илрүүлсэн, тухайн нэгжийн нөөцөөр " +
      "шийдвэрлэх боломжтой эрсдэлүүд.",
    steps: [
      {
        title: "Эрсдэлээ бүртгэ",
        text: "Аюул, түүний үр дагавар, одоо байгаа хяналтыг тодорхойлно.",
      },
      {
        title: "Арга хэмжээ төлөвлө",
        text:
          "Хэн, хэзээ, ямар нөөцөөр хэрэгжүүлэхийг тодорхой бичнэ. " +
          "Хугацаагүй арга хэмжээ хэрэгждэггүй.",
      },
      {
        title: "Биелэлтийг тэмдэглэ",
        text: "Хэрэгжсэн арга хэмжээг баримт хавсаргаж хаана.",
      },
    ],
  },

  "risk/bn-approve": {
    title: "Бүтцийн нэгжийн батламж",
    intro:
      "БН-ийн дарга өөрийн нэгжийн эрсдэлийн үнэлгээг хянаж, батлах " +
      "эсвэл засуулахаар буцаах хуудас.",
    steps: [
      {
        title: "Хүлээгдэж буйг шүүж ол",
        text: "«Батлуулахаар илгээсэн» төлөвтэй үнэлгээг эхлээд хараарай.",
      },
      {
        title: "Үнэлгээг нээж шалга",
        text:
          "Аюул зөв тодорхойлогдсон уу, оноо бодитой юу, арга хэмжээ " +
          "хэрэгжих боломжтой юу гэдгийг шалгана.",
      },
      {
        title: "Шийдвэр гаргах",
        text:
          "Батлах — дараагийн шатанд шилжинэ. Буцаах — шалтгаанаа заавал " +
          "бичнэ, эс бөгөөс бүртгэсэн хүн юуг засахаа мэдэхгүй.",
      },
    ],
    notes: [
      "Өндөр эрсдэлтэй (20-25) үнэлгээ нь ЭҮХ-нд заавал хэлэлцэгдэнэ.",
    ],
  },

  "risk/committee": {
    title: "Эрсдэлийн үнэлгээний хороо (ЭҮХ)",
    intro:
      "Бүтцийн нэгжээс ирсэн эрсдэлийг хамтын хурлаар хэлэлцэж, санал " +
      "хураалтаар шийдвэрлэх хуудас.",
    steps: [
      {
        title: "Хэлэлцэх эрсдэлийг сонго",
        text: "Хороонд ирсэн жагсаалтаас тухайн хуралд авах зүйлээ тэмдэглэнэ.",
      },
      {
        title: "Санал хураа",
        text:
          "Гишүүн бүр өөрийн саналаа өгнө. Санал хураалт дуусах хүртэл " +
          "шийдвэр гарахгүй.",
      },
      {
        title: "Шийдвэрийг баталгаажуул",
        text:
          "Олонхийн саналаар шийдвэр гарна. Удирдлагын түвшинд шилжүүлэх " +
          "шаардлагатай бол тэмдэглэнэ.",
      },
    ],
    notes: [
      "Гишүүдийн бүрэлдэхүүнийг «ЭҮХ-ны гишүүд» хуудсаас удирдана.",
    ],
  },

  "risk/management": {
    title: "Удирдлагын хороо",
    intro:
      "ЭҮХ-ноос дээшлүүлсэн, үйлдвэрийн түвшинд шийдвэрлэх шаардлагатай " +
      "эрсдэлийг хэлэлцэх хуудас.",
    steps: [
      {
        title: "Дээшлүүлсэн эрсдэлийг хараарай",
        text: "ЭҮХ хэлэлцээд удирдлагад шилжүүлсэн зүйл энд ирнэ.",
      },
      {
        title: "Санал хураалт",
        text: "Гишүүн бүр саналаа өгнө; хүчинтэй болох тоо бүрдэх ёстой.",
      },
      {
        title: "Батлагдсан төлөвлөгөө",
        text:
          "Батлагдсан арга хэмжээ «Батлагдсан төлөвлөгөө» хуудсанд " +
          "шилжиж, биелэлт нь тэндээс хянагдана.",
      },
    ],
  },

  "risk/plan": {
    title: "Эрсдэл бууруулах төлөвлөгөө",
    intro:
      "Батлагдсан арга хэмжээний хэрэгжилтийг хугацаа, хариуцагчаар " +
      "хянах хуудас.",
    steps: [
      {
        title: "Хугацаа хэтэрсэнийг эхлээд хараарай",
        text: "Улаанаар тэмдэглэгдсэн мөр нь хугацаа хэтэрсэн арга хэмжээ.",
      },
      {
        title: "Биелэлт тэмдэглэ",
        text: "Хэрэгжсэн ажлыг баримт (зураг, акт) хавсаргаж баталгаажуулна.",
      },
    ],
    notes: [
      "Биелэлтгүй хаагдсан арга хэмжээ нь дараагийн аудитад цоорхой болно.",
    ],
  },

  "risk/annual-hazards": {
    title: "Жилийн аюулын жагсаалтын төлөвлөгөө",
    intro:
      "Дараа жил ажиллах аюулын жагсаалтыг урьдчилан төлөвлөж, ЭҮХ-оор " +
      "батлуулах хуудас. Батлагдсан жагсаалт нь тухайн жилийн ажиллах " +
      "жагсаалт болно.",
    steps: [
      {
        title: "ДАРАА жилээ сонго",
        text:
          "Хуудас нээхэд дараа жил анхдагчаар гарна. Жагсаалтыг тухайн " +
          "жилдээ биш, УРЬДЧИЛАН төлөвлөдөг — эхлээд төлөвлөж, батлуулж " +
          "байж дараа жилдээ ажиллана.",
      },
      {
        title: "Хөрвүүл",
        text:
          "Тэгээс эхлэхгүй. Өнгөрсөн жилийн БАТЛАГДСАН жагсаалтаас " +
          "үргэлжлэн байгаа аюулаа сонгож хөрвүүлнэ. Эхний жилд бол " +
          "аюулын нэгдсэн лавлахаас (2025 оны 100 аюул) авна. Ангиллаар " +
          "шүүж, «Харагдаж буй бүгдийг сонгох»-оор бөөнөөр авна.",
      },
      {
        title: "«Өнгөрсөн → одоо» зөрүүг унш",
        text:
          "Хөрвүүлэх үед утга нь лавлахаас ДАХИН уншигдана. Оноо 20 → 12 " +
          "бол өнгөрсөн жилийн арга хэмжээ ажилласан; 20 → 20 бол " +
          "хөдлөөгүй; өссөн бол байдал муудсан. «давтагдсан» шошготой " +
          "аюул нь олон жил жагсаалтад байсан гэсэн үг.",
      },
      {
        title: "Шинэ аюул нэмэх",
        text:
          "Хоёр арга: ① лавлахад бүртгэлтэй, энэ жагсаалтад ороогүй " +
          "аюулаас сонгох ② лавлахад ч байхгүй ЦОО ШИНЭ аюулыг бүртгэх — " +
          "энэ нь аюулын нэгдсэн лавлахад ч давхар нэмэгдэнэ.",
      },
      {
        title: "ЭҮХ-д илгээ",
        text:
          "Илгээсэн мөчөөс мөр ТҮГЖИГДЭНЭ. Гишүүд санал өгч, олонхийн " +
          "саналаар батлагдана.",
      },
    ],
    notes: [
      "⚠ Батлагдсаны дараа жагсаалт өөрчлөгдөхгүй. Мөрийн утга нь " +
        "лавлахаас хуулагдсан тул лавлах хожим засагдсан ч баримт хэвээр.",
      "Батлагдсан жагсаалтыг лавлахын хуудсаас (/risk/reference/factor) " +
        "жилээр нь сонгож харна — «20XX онд мөрдөгдөх жагсаалт». Тэр " +
        "горимд засах боломжгүй: засвар нь ажлын лавлах дээр хийгдэж, " +
        "дараа жилийн жагсаалтад тусна.",
      "Эх үүсвэрийн багана нь «Дамжсан» / «Шинэ» гэж ялгана. Хоёр дахь " +
        "жилдээ давтагдаж буй аюулыг шинэ илрүүлэлттэй ижил жинтэй үзэж " +
        "болохгүй — арга хэмжээ ажиллаагүй гэсэн дохио.",
    ],
    rule: "ХЭМАБМТ-05 · эрсдэлийн удирдлагын журам",
  },

  "my-assignments": {
    title: "Миний даалгавар",
    intro:
      "Хяналт шалгалтаар танд хувиарлагдсан зөрчлийг арилгах ажлууд. " +
      "Биелэлтээ эндээс илгээнэ.",
    steps: [
      {
        title: "Хийх ёстойгоо хараарай",
        text:
          "Дээд талын картууд төлөвөөр шүүнэ. «Хугацаа хэтэрсэн» улаан " +
          "тоо нь хамгийн түрүүнд анхаарах ажил.",
      },
      {
        title: "Биелэлтээ оруул",
        text:
          "«Биелэлт оруулах» дарж юуг хэрхэн засаж арилгасныг тодорхой " +
          "бичнэ. Тайлбаргүй биелэлт нь дараагийн аудитад нотлогдохгүй.",
      },
      {
        title: "Баталгаажилтыг хүлээ",
        text:
          "Илгээсний дараа шалгагч хүлээн авч хаана. Буцаагдвал шалтгаан " +
          "нь улаан талбарт харагдана — түүнийг заасны дагуу засаад дахин " +
          "илгээнэ.",
      },
    ],
    notes: [
      "⚠ Өөрийн биелэлтийг өөрөө хаах боломжгүй — баталгаажуулалтыг " +
        "шалгасан хүн эсвэл ХАБЭА хэлтэс хийнэ.",
      "«Хугацаа заагаагүй» гэж гарвал шалгагчаас тодруулна уу — " +
        "хугацаагүй даалгавар хэрэгждэггүй.",
    ],
    rule: "ХЭМАБМТ-06 · хяналт шалгалтын журам",
  },

  "hazard/triage": {
    title: "Аюулын мэдээллийг ангилах",
    intro:
      "Ирсэн мэдээлэлд ЭЗЭН ба ХУГАЦАА өгөх хуудас. Эзэнгүй мэдээлэл " +
      "хэнийг ч хүлээхгүй тул «Шинэ» дээр хуримтлагддаг — энэ хуудас яг " +
      "тэр гацааг арилгахад зориулагдсан.",
    steps: [
      {
        title: "«Эзэн хүлээж буй»-г эхэлж ав",
        text:
          "Шүүлтээс «Эзэн хүлээж буй» сонгоно — эдгээр нь хэн ч " +
          "хариуцаагүй, тиймээс ХЭЗЭЭ Ч шийдэгдэхгүй мэдээллүүд.",
      },
      {
        title: "Мэдээллийг уншиж ойлго",
        text:
          "Тайлбар, зураг, байршлыг хараад ямар аюул болохыг тогтооно. " +
          "Тодорхойгүй бол мэдээлсэн хүнээс тодруулах нь буруу хүнд " +
          "хуваарилахаас дээр.",
      },
      {
        title: "«Хуваарилах» — эзэн ба хугацаа",
        text:
          "Арилгах хүнийг сонгоод хугацаа тавина. «Тэмдэглэл» нь заавал " +
          "биш ч юуг хийхийг тодорхой бичвэл ажил хоёр удаа эргэхгүй.",
      },
      {
        title: "Хугацаа хэтэрсэнийг хяна",
        text:
          "«Хугацаа хэтэрсэн» шүүлт нь эзэнтэй БОЛОВЧ хийгдээгүйг " +
          "харуулна — эзэн өгөөд мартах нь ангилаагүйтэй адил.",
      },
    ],
    roles: [
      {
        role: "АШУА · хэсгийн дарга",
        text:
          "Өөрийн хэсэгт ирсэн мэдээллийг ангилж, эзэн ба хугацаа өгнө. " +
          "Өөрөө арилгах боломжтойг шууд хуваарилж болно.",
      },
      {
        role: "БН-ийн ХАБ ажилтан",
        text:
          "Ангилагдаагүй хуримтлалыг хянаж, хоцорсныг сануулна.",
      },
      {
        role: "ХАБЭА хэлтэс",
        text:
          "Бүх БН-ийн ангилалгүй ба хугацаа хэтэрсэн хуримтлалыг хараад " +
          "БН-үүдэд шаардлага тавина.",
      },
    ],
    notes: [
      "Эзэн ба хугацаа хоёулаа байхгүй мэдээлэл нь бүртгэгдсэн ч " +
        "шийдэгдэхгүй — ангилах нь албан шаардлага биш, ПРОЦЕССЫН нөхцөл.",
      "Хуваарилсны дараа эзэн нь /my-assignments дээр өөрийн даалгаврыг " +
        "харна.",
    ],
    rule: "ХЭМАБМТ-04 · аюулын мэдээллийн журам",
  },

  "hazard/dashboard": {
    title: "Аюулын хяналтын самбар",
    intro:
      "Аюулын мэдээллийн ерөнхий зураг: хэдэн мэдээлэл ирсэн, хэд нь " +
      "ангилагдсан, хэд нь хаагдсан, хаана хуримтлагдаж байна.",
    steps: [
      {
        title: "Хугацаа, нэгжээ шүү",
        text:
          "Доорх БҮХ тоо шүүлтээс хамаарна. Таны эрхээс хамаарч харах " +
          "нэгжүүд хязгаарлагдана.",
      },
      {
        title: "Гацааг ол",
        text:
          "«Шинэ» (ангилагдаагүй) ба «хугацаа хэтэрсэн» тоо нь хамгийн " +
          "чухал: эдгээр нь шийдэгдэхгүй хуримтлал. Тоо дээр дарж " +
          "жагсаалт руу шилжинэ.",
      },
      {
        title: "Ангилал, байршлаар задла",
        text:
          "Аль төрлийн аюул, аль нэгжид давамгайлж байгааг хараад " +
          "зорилтот хяналт төлөвлөнө.",
      },
    ],
    roles: [
      {
        role: "БН-ийн удирдлага",
        text: "Өөрийн БН-ийн хуримтлал, хугацаа хэтрэлтийг хянана.",
      },
      {
        role: "ХАБЭА хэлтэс",
        text:
          "Бүх БН-ийг харьцуулна. Хуримтлал өссөн БН-д шаардлага тавина.",
      },
      {
        role: "Ажилтан",
        text:
          "Өөрийн мэдээлсэн аюулын төлвийг /hazard/board дээр хянана.",
      },
    ],
    notes: [
      "Энэ самбар ЗӨВХӨН ХАРАХ зориулалттай — ангилах, батлах нь " +
        "/hazard/triage · /hazard/verify дээр.",
      "Аюул (ZR-) ба хяналт шалгалтын зөрчил (INS-) нь ТУСДАА бүртгэл — " +
        "энэ самбар нь зөвхөн аюулынх.",
    ],
    rule: "ХЭМАБМТ-04 · аюулын мэдээллийн журам",
  },

  "risk/reports": {
    title: "Эрсдэлийн тайлан",
    intro:
      "Эрсдэлийн үнэлгээний БАТЛУУЛАХ баримтуудыг бүртгэлээс шууд " +
      "угсарч, хэвлэх ба Excel-ээр татах хуудас. Word дээр гараар " +
      "бичих шаардлагагүй болно.",
    steps: [
      {
        title: "Нэгдсэн үнэлгээ (бүх БН)",
        text:
          "«Бүтцийн нэгжүүдийн эрсдэлийн түвшинг бууруулах арга хэмжээний " +
          "төлөвлөгөө» — Ерөнхий инженер батална. Нэгж бүрийн үнэлсэн ажлын " +
          "тоо, эрсдэл өндөр гарсан ажлын байр, түүнээс нэгж өөрөө хянах ба " +
          "хороогоор хэлэлцэх тоо, шаардагдах тоног төхөөрөмж, зардал гарна.",
      },
      {
        title: "БН / хэсгийн үнэлгээ",
        text:
          "Цех, хэсгээ сонгоход тухайн нэгжийн багц гарна: эрэмбэлсэн " +
          "жагсаалт, үнэлгээний бүртгэл (7 багана), аюулын жагсаалт, " +
          "матриц. Цехийн дарга батална.",
      },
      {
        title: "Хэвлэх / татах",
        text:
          "«Хэвлэх» нь A4 хэвтээ, цаасан маягтын бүтцээр гарна. «Excel " +
          "татах» нь ижил хүснэгтийг нэг хуудсанд буулгана.",
      },
    ],
    notes: [
      "Ажлын ЭРЭМБЭ нь түүний хамгийн ӨНДӨР эрсдэлийн мөрөөр тодорхойлогдоно " +
        "— дундажлавал нэг ноцтой аюул олон бага аюулд живнэ.",
      "«Үүнээс» хоёр багана нь хөрөнгө оруулалт шаардах эсэхээр салдаг. " +
        "Нийлбэр нь «эрсдэл өндөр» баганатай таарахгүй бол аль нэг " +
        "үнэлгээн дээр тэмдэглэгээ дутуу байна гэсэн үг.",
      "«Боломж» багана нь баазад эх сурвалжгүй тул хоосон гарна — " +
        "хэвлэсний дараа гараар бичнэ.",
    ],
  },
  "risk/measure-progress": {
    title: "Хяналтын арга хэмжээний биелэлт",
    intro:
      "Эрсдэлийн үнэлгээгээр төлөвлөсөн арга хэмжээ ҮНЭНДЭЭ хэрэгжсэн " +
      "эсэхийг бүртгэдэг хуудас. Хариуцагч биелүүлснээ бүртгэж, ХАБЭА " +
      "баталгаажуулж байж «хэрэгжсэн» гэж тооцогдоно.",
    steps: [
      {
        title: "Өөрийн арга хэмжээг ол",
        text:
          "Жагсаалтад таны хариуцах арга хэмжээ гарна. «Хугацаа хэтэрсэн» " +
          "шүүлтээр яаралтайг нь эхэлж хараарай.",
      },
      {
        title: "«Биелүүлсэн» гэж бүртгэ",
        text:
          "Хэрэгжүүлсэн огноо + хийсэн ажлаа товч бичнэ. Тайлбар нь " +
          "баталгаажуулагчийн шалгах ганц мэдээлэл тул тодорхой бичнэ.",
      },
      {
        title: "ХАБЭА баталгаажуулна",
        text:
          "ХАБЭА хэлтэс «Шалгах» дараад батална эсвэл шалтгаан бичиж " +
          "буцаана. Буцаасан арга хэмжээ дахин нээлттэй болж, шинээр " +
          "биелэлт бүртгэх боломжтой.",
      },
    ],
    notes: [
      "Өөрийн бүртгэсэн биелэлтийг ӨӨРӨӨ баталгаажуулах боломжгүй — тоо " +
        "өөрөө өөрийгөө баталсан мөрөөр дүүрэхээс сэргийлсэн.",
      "«Эзэнгүй» гэсэн улбар шар тэмдэглэгээ нь үнэлгээ дээр хариуцагч " +
        "сонгоогүй гэсэн үг — эрсдэлийн үнэлгээ рүү орж хариуцагч, хугацааг " +
        "нөхөж оруулна.",
      "Зөвхөн баталгаажсан арга хэмжээ л сарын тайлангийн «эрсдэлийн " +
        "түвшин бууруулсан» үзүүлэлтэд тоологдоно.",
    ],
  },
  "naryad/register": {
    title: "Ажлын даалгаврын бүртгэл",
    intro:
      "Хэсгийн дарга / мастер ажил үүсгэж, тухайн ажилд гарах ажилтнуудаа " +
      "бүртгэдэг хуудас. Бүртгэгдсэн ажилтан 5А дадлын асуумжаа бөглөж " +
      "байж ажилд гарна.",
    steps: [
      {
        title: "Ажлаа үүсгэ",
        text:
          "«Шинэ ажил үүсгэх» — хугацаа (эхлэх/дуусах), хариуцах хэсэг, " +
          "ажлын тайлбар. Ажил өөр нэгжид хийгдэх бол «Хийж гүйцэтгэх газар " +
          "тусдаа» гэснийг тэмдэглэнэ.",
      },
      {
        title: "Ажилтнаа бүртгэ",
        text:
          "Ажлын мөрөн дэх цэнхэр товчоор ажилтан нэмнэ. Бүртгэлийн дугаар " +
          "бичээд «Татах» дархад нэр, албан тушаал автоматаар бөглөгдөнө. " +
          "Нэг ажилтан ӨӨР ӨДӨР дахин бүртгэгдэж болно (өдөр бүр 5А бөглөнө).",
      },
      {
        title: "5А-гийн биелэлтийг хяна",
        text:
          "Мөр бүрийн «5А: 3/5» шугам нь хэдэн хүн бөглөснийг харуулна. " +
          "«5А дутуу» шүүлтээр бөглөөгүй ажилтантай ажлуудыг шууд шүүнэ.",
      },
      {
        title: "Ажилд гаргах зөвшөөрөл өг",
        text:
          "Бөглөсөн ажилтан бүрийг «Ажилд гаргах зөвшөөрөл» хуудсаар " +
          "зөвшөөрч эсвэл татгалзана — зөвшөөрөлгүй хүн ажилд гарахгүй.",
      },
    ],
    notes: [
      "Төлөв нь ОГНООНООС тооцогдоно: Товлосон (эхлээгүй) · Идэвхтэй " +
        "(өнөөдөр үргэлжилж буй) · Дууссан.",
      "Дууссан ажилд ажилтан нэмэх боломжгүй — шаардлагатай бол ажлын " +
        "дуусах хугацааг эхлээд сунгана.",
      "Хайлт нь ажлын тайлбараас гадна АЖИЛТНЫ нэр, ТН-ээр ажиллана.",
      "ХАБ хэлтсээс хуваарилагдсан аюулын ажил хуудасны дээд талд гарна — " +
        "тэндээс шууд наряд үүсгэвэл мэдээлэл нь урьдчилан бөглөгдөнө.",
    ],
  },

  // ── Ажилтан өөрөө шийдэх процесс ──────────────────────────────────
  "hazard/board": {
    title: "Нээлттэй аюулын самбар",
    intro:
      "Үйлдвэр ДАЯАР бүртгэгдсэн, хараахан шийдэгдээгүй аюул, зөрчлийн " +
      "жагсаалт. Өөрөө арилгах боломжтойгоо сонгоод авсан арга хэмжээгээ " +
      "бүртгэнэ — дараа нь удирдлага баталгаажуулна.",
    steps: [
      {
        title: "Өөрт хамаарахыг ол",
        text:
          "Шүүлтээр байршил, ангиллаар хайна. Энэ жагсаалт нь ҮЙЛДВЭР " +
          "ДАЯАР — өөрийн бүртгэлээс гадна бусдын мэдээлсэн аюул ч " +
          "харагдана.",
      },
      {
        title: "Зургийг хараад ойлго",
        text:
          "Бүртгэсэн хүний зураг, тайлбарыг уншиж юу засах шаардлагатайг " +
          "тогтооно.",
      },
      {
        title: "«Би өөрөө шийдлээ» дар",
        text:
          "Аюулыг арилгасны ДАРАА дарна. Авсан арга хэмжээгээ бичиж, " +
          "боломжтой бол ЗАСАЛТЫН зураг хавсаргана.",
      },
      {
        title: "Баталгаажуулалтыг хүлээ",
        text:
          "Бүртгэл удирдлага руу (/hazard/verify) очно. Батлагдвал " +
          "хаагдаж, урамшууллын үзүүлэлтэд тоологдоно. Буцаагдвал " +
          "шалтгаан нь ирнэ.",
      },
    ],
    roles: [
      {
        role: "Ажилтан (хэн ч)",
        text:
          "Өөрийн боломжийн хүрээнд аюулыг арилгаад бүртгэнэ. Энэ нь " +
          "урамшууллын эх өгөгдөл болно.",
      },
      {
        role: "АШУА · удирдлага",
        text:
          "Самбарыг хараад хэн ч аваагүй аюулыг ангилах руу " +
          "(/hazard/triage) шилжүүлж эзэн өгнө.",
      },
      {
        role: "ХАБЭА хэлтэс",
        text:
          "Нээлттэй хуримтлалыг БН-ээр хянана — урт хугацаанд " +
          "хөндөгдөөгүй аюул нь системийн бэрхшээлийн шинж.",
      },
    ],
    notes: [
      "«Өөрөө шийдсэн» нь ШУУД хаагддаггүй — удирдлага баталгаажуулах " +
        "хүртэл нээлттэй хэвээр.",
      "Аюулыг арилгаагүй байж «шийдлээ» гэж бүртгэх нь хамгийн хортой " +
        "зөрчил: дараагийн ажилтан хамгаалалтгүй үлдэнэ.",
    ],
    rule: "ХЭМАБМТ-04 · аюулын мэдээллийн журам",
  },

  "hazard/verify": {
    title: "Өөрөө шийдсэнийг баталгаажуулах",
    intro:
      "Ажилтны «би өөрөө арилгасан» гэсэн бүртгэлийг удирдлага уншиж " +
      "БАТЛАНА (хаагдана) эсвэл ШАЛТГААНТАЙ буцаана. Хоёр таб: " +
      "«Хүлээгдэж буй» ба ажилтан бүрээрх «Үзүүлэлт».",
    steps: [
      {
        title: "«Хүлээгдэж буй» табаас эхэл",
        text:
          "Эдгээр нь ажилтан ажлаа хийчихээд ТАНЫ шийдвэрийг хүлээж " +
          "байгаа бүртгэлүүд. Хүлээлт урт байвал ажилчид дараа нь " +
          "бүртгэхээ болино.",
      },
      {
        title: "Авсан арга хэмжээг унш",
        text:
          "«Авсан арга хэмжээ» ба засалтын зургийг аюулын эх зурагтай " +
          "тулгана. Зөвхөн текст уншаад батлах нь баталгаажуулалтын " +
          "утгыг алдагдуулна.",
      },
      {
        title: "Батла эсвэл шалтгаантай буцаа",
        text:
          "Батлагдвал аюул ХААГДАНА. Дутуу бол ШАЛТГААН бичиж буцаана — " +
          "шалтгаангүй буцаалт нь ажилтанд юуг засахаа хэлэхгүй.",
      },
      {
        title: "«Үзүүлэлт» табаар урамшууллыг бэлд",
        text:
          "Ажилтан бүрээр шийдсэн / баталгаажсан / буцаагдсан тоо ба " +
          "батлагдалтын хувь харагдана — урамшууллын шийдвэрийн эх " +
          "өгөгдөл нь энэ.",
      },
    ],
    roles: [
      {
        role: "АШУА · хэсгийн дарга",
        text:
          "Өөрийн хэсгийн ажилтны шийдлийг баталгаажуулна (SSO бүлэг " +
          "166/167/168).",
      },
      {
        role: "БН-ийн удирдлага",
        text:
          "Хүлээгдэж буй хуримтлалыг хянана: удаан хүлээлт нь ажилчдын " +
          "оролцоог унагадаг.",
      },
      {
        role: "ХАБЭА хэлтэс",
        text:
          "Бүх БН-ийг баталгаажуулж чадна. «Үзүүлэлт» табаар урамшууллын " +
          "жагсаалтыг гаргана.",
      },
    ],
    notes: [
      "АШУА-гийн АЛБАН жагсаалт баазад байхгүй тул баталгаажуулах эрхийг " +
        "удирдлагын БҮЛГЭЭР (166/167/168) эсвэл ХАБЭА хэлтсээр шалгадаг.",
      "Батлагдсаны дараа аюул хаагдана — дахин нээх шаардлагатай бол " +
        "шинээр бүртгэнэ.",
    ],
    rule: "ХЭМАБМТ-04 · аюулын мэдээллийн журам",
  },

  "hazard/register": {
    title: "Аюулын мэдээлэл бүртгэх",
    intro:
      "Ажлын байранд харсан аюул, зөрчил, эмзэг нөхцөлийг мэдээлэх маягт. " +
      "Эрхээс ҮЛ ХАМААРАН БҮХ ажилтан бүртгэж болно — наряд авсан эсэхээс " +
      "хамаарахгүй.",
    steps: [
      {
        title: "Юу харснаа бич",
        text:
          "Тайлбарыг тодорхой бич: ЮУ, ХААНА, ЯМАР нөхцөлд. «Гэмтэлтэй» " +
          "гэхээсээ «3-р шатны шатны бариул тасарсан» гэж бичвэл " +
          "шийдвэрлэхэд хамаагүй хурдан.",
      },
      {
        title: "Байршлаа заа",
        text:
          "Цех, хэсэг, ажлын байраа сонгоно. Байршил нь дараа нь ХЭН " +
          "арилгахыг тодорхойлдог гол мэдээлэл.",
      },
      {
        title: "Зураг хавсарга",
        text:
          "Зураг нь тайлбараас илүү хүчтэй. Утаснаасаа шууд авч хавсаргаж " +
          "болно. Дуугаар бичих боломж ч бий (Чимэгэ → текст).",
      },
      {
        title: "Илгээ",
        text:
          "Илгээмэгц мэдээлэл «Шинэ» төлөвт орж, ангилах хуудсанд " +
          "(/hazard/triage) харагдана. Дугаар нь ZR- гэж эхэлнэ.",
      },
    ],
    roles: [
      {
        role: "Ажилтан (хэн ч)",
        text:
          "Харсан аюулаа бүртгэнэ. Эрх, наряд шаардлагагүй. Бүртгэснийхээ " +
          "төлвийг /hazard/board дээр хянаж болно.",
      },
      {
        role: "Наряд авсан ажилтан",
        text:
          "15 асуумж (ӨЭА) дээр аюул илрүүлбэл тэндээсээ шууд энэ маягт " +
          "руу шилжинэ — байршил, наряд нь өөрөө бөглөгдөнө.",
      },
      {
        role: "АШУА · удирдлага",
        text:
          "Мөн бүртгэнэ, гэхдээ гол үүрэг нь ангилах ба баталгаажуулах " +
          "(/hazard/triage · /hazard/verify).",
      },
      {
        role: "ХАБЭА мэргэжилтэн",
        text:
          "Зөрчил, үзлэгийн бүртгэл нь ӨӨР хуудас: /incident/register. " +
          "Энэ маягт нь ажилтны мэдээлэлд зориулагдсан.",
      },
    ],
    notes: [
      "Ажил зогсоох шаардлагатай аюул бол 15 асуумж дээр «Тийм» гэж " +
        "хариулснаар зогсолт АВТОМАТААР үүснэ — энд гараар бүртгэх " +
        "шаардлагагүй.",
      "Аюул (ZR-) ба хяналт шалгалтын зөрчил (INS-) нь ТУСДАА бүртгэл — " +
        "хоёуланг нэг тайланд нийлүүлэхгүй.",
    ],
    rule: "ХЭМАБМТ-04 · аюулын мэдээллийн журам",
  },

  "highrisk/register": {
    title: "ӨЭА наряд бүртгэх",
    intro:
      "Өндөр эрсдэлт ажлын зөвшөөрөл (наряд) нээх маягт — ажлын " +
      "агуулга, байршил, тоног төхөөрөмж, хугацаа.",
    steps: [
      {
        title: "Ажлаа тодорхойл",
        text:
          "Цех, нэгж, ажлын байр, гүйцэтгэх ажлын товч агуулгыг бичнэ. " +
          "Ажил эхлэх / дуусах хугацааг ҮНЭН оруулна — хугацаа дуусахад " +
          "наряд автоматаар хүчингүй болно.",
      },
      {
        title: "Тоног төхөөрөмжөө сонго",
        text:
          "Төхөөрөмжөө сонгоход систем түүнд харгалзах ТЕХНОЛОГИЙН КАРТ " +
          "болон ХАБЭА-гийн зааврыг (3.1 / 3.2) автоматаар санал болгоно.",
      },
      {
        title: "Хадгалж, дараагийн хэсгүүдийг бөглө",
        text:
          "Наряд хадгалсны дараа л гарын үсэг, аюулгүйн хангамж, " +
          "бригад, ээлжийн хэсгүүд нээгдэнэ — эхлээд хадгална.",
      },
      {
        title: "§2.2 Тусгаарлалт хийх ТТ-г СОНГО",
        text:
          "Цахилгаан схем задлах, пайз, цоож зүүх төхөөрөмжөө лавлахаас " +
          "сонгоно — гараар бичихээ больсон. Мөр бүрд цоож/пайзны " +
          "дугаараа тодруулгад бичнэ. Энэ хэсэг ТУСДАА «Хадгалах» " +
          "товчтой: дарахгүй бол өөрчлөлт хадгалагдахгүй.",
      },
      {
        title: "§4-т хариуцлагатай ИТА-г томил",
        text:
          "Дүр бүрд хүн нэмнэ. Үйлдвэрийн ажилтныг Б/Д-аар нэмэхэд нэр, " +
          "албан тушаал автоматаар татагдана. Гэрээт байгууллагын хүнийг " +
          "БАЙГУУЛЛАГА сонгоод, дараа нь АЖИЛТНАА сонгоно. Нэмсэн хүнээ " +
          "харандааны товчоор засна.",
      },
      {
        title: "Батлуулахаар илгээ",
        text:
          "Бүх хэсгийг гүйцээсний дараа зөвшөөрөл олгогчид илгээнэ. " +
          "Баталсны дараа маягтыг хэвлэж, ажлын байранд байлгана.",
      },
    ],
    notes: [
      "⚠ Батлагдсан нарядыг засах боломжгүй. Алдаа гарвал шинээр нээнэ.",
      "Наряд нээлттэй байхад бригадын бүрэлдэхүүн өөрчлөгдвөл ЗААВАЛ " +
        "шинэчилж бүртгэнэ.",
      "⚠ НЭГ ХҮН ХОЁР ДҮРД БАЙВАЛ шар анхааруулга гарна. Ажилд оруулагч " +
        "нь ажлын байрыг ШАЛГАЖ нээдэг, гүйцэтгэгч нь ажлыг ХИЙДЭГ — нэг " +
        "хүн хоёуланг нь эзэлбэл өөрийгөө шалгаж байгаа хэрэг. Систем " +
        "зогсоохгүй ч өөр хүн томилох боломжтой эсэхийг нягтална уу.",
      "⚠ §5/§6-д ээлж нээх/хаах гарын үсгийг ЗӨВХӨН §4-т тэр дүрээр " +
        "бүртгэгдсэн хүн зурна. §4-т «Ажил гүйцэтгэгч» гэж бүртгэгдсэн " +
        "хүн «Ажилд оруулагч» мөрийг зурж чадахгүй. §4 хоосон бол " +
        "зөвшөөрөх ч анхааруулна.",
      "§2.2-т юу ч сонгоогүй бол хэвлэсэн хуудсанд ХООСОН гарна. Өмнө нь " +
        "ажлын бүх ТТ цувж гардаг байсан нь БУРУУ байсан — тусгаарлах " +
        "төхөөрөмж (тэжээлийн шүүгээ, таслуур) нь ажлын ТТ-ээс өөр.",
      "Хавсаргасан төсөл, хэмжилтийн дүн одоо хэвлэсэн хуудасны §3.3/§3.4-т " +
        "нэрээрээ гарна.",
    ],
    rule: "ХЭМАБМТ-15 · өндөр эрсдэлт ажлын журам",
  },

  "highrisk/list": {
    title: "ӨЭА нарядын жагсаалт",
    intro:
      "Нээгдсэн, батлагдсан, хаагдсан бүх нарядыг шүүж харах хуудас.",
    steps: [
      {
        title: "Төлөвөөр шүүж хараарай",
        text:
          "Нээлттэй наряд эхлээд харагдана — эдгээр нь ЯГ ОДОО ажил " +
          "явагдаж байгаа газрууд.",
      },
      {
        title: "Дэлгэрэнгүй нээ",
        text:
          "Мөр дээр дарж гарын үсэг, хангамж, бригад, ээлжийн бүх " +
          "мэдээллийг харна.",
      },
      {
        title: "«Шатны явц» баганаас гацсаныг ол",
        text:
          "§4 ИТА → §5 ээлж нээх → §6 ээлж хаах гэсэн дөрвөн алхмын " +
          "хувь харагдана. Доор нь дүр тус бүрийн гарын үсэг " +
          "«зурсан/нийт» гэж, ⏳ тэмдэгтэй мөрөнд ХЭНИЙГ хүлээж байгаа " +
          "нь бичигдэнэ. Багана дээр хулгана аваачвал бүх нэрс гарна.",
      },
      {
        title: "Өөртэйгээ холбоотойг нь шүүж ав",
        text:
          "«Миний оролцсон» — би §4-т томилогдсон эсвэл §5/§6-д гарын " +
          "үсэг зурсан наряд. «Миний гарын үсэг хүлээгдэж буй» — надаас " +
          "болж гацаж байгаа нь. ИТА-гийн нэр эсвэл Б/Д-аар ч хайна.",
      },
      {
        title: "Хэвлэ",
        text:
          "Хэвлэх товч нь зөвшөөрлийн албан ёсны маягтыг гаргана. " +
          "Хуудас таарахгүй бол хэвлэхийн өмнөх харагдацаас шалгана.",
      },
    ],
    notes: [
      "Хугацаа дууссан ч хаагдаагүй наряд улаанаар тэмдэглэгдэнэ — " +
        "эдгээрийг эзэн нь хаах ёстой.",
      "⚠ §4 бүрэн ч ажил хийгдээгүй (ээлж нээгээгүй) бол явц 100% " +
        "БОЛОХГҮЙ — 50% гэж харагдана. Наряд бичээд ажил эхлээгүй " +
        "тохиолдол яг ийм харагдах ёстой.",
      "Ээлж нь ажилд оруулагч БА гүйцэтгэгч ХОЁУЛАА зурсан үед л " +
        "«нээгдсэн» гэж тооцогдоно. Нэг тал зурсан бол ажлын байр " +
        "хараахан хүлээлцээгүй гэсэн үг.",
      "Багана «—» гэж хоосон харагдвал энэ нь «явц тэг» гэсэн үг БИШ — " +
        "шатны мэдээлэл татагдаагүй байна.",
    ],
  },

  "highrisk/approve": {
    title: "ӨЭА наряд батлах",
    intro:
      "Зөвшөөрөл олгогч нарядыг хянаж, ажил эхлүүлэх эсэхийг шийдэх хуудас.",
    steps: [
      {
        title: "Хүлээгдэж буйг эхлээд хараарай",
        text: "Батлуулахаар илгээсэн наряд жагсаалтын эхэнд гарна.",
      },
      {
        title: "Гурвыг заавал шалга",
        text:
          "① Аюулгүй ажиллагааны хангамж бүрэн үү ② Бригадын гишүүд " +
          "зааварчилгаа авсан уу ③ Тусгаарлалт хийгдсэн үү.",
      },
      {
        title: "Шийдвэр гаргах",
        text:
          "Батлах — ажил эхлэх зөвшөөрөл олгогдоно. Буцаах — шалтгаанаа " +
          "заавал бичнэ.",
      },
    ],
    notes: [
      "⚠ Баталсан хүн нь тухайн ажлын аюулгүй байдалд ХАРИУЦЛАГА хүлээнэ. " +
        "Газар дээр нь шалгаагүй бол бүү батал.",
    ],
  },

  "highrisk/registerTn": {
    title: "ӨЭА-д гарах ажилтны бүртгэл",
    intro:
      "Тухайн өдөр өндөр эрсдэлт ажилд гарах ажилтнуудыг нэрээр нь " +
      "бүртгэнэ. АШУА (нэгжийн хариуцлагатан) бөглөнө.",
    steps: [
      {
        title: "Огноогоо шалга",
        text:
          "Бүртгэл нь ӨДРӨӨР хөтлөгдөнө. Буруу өдөр рүү бүртгэвэл " +
          "ажилтанд урьдчилсан шалгалт нь гарч ирэхгүй.",
      },
      {
        title: "ЯМАР АЖИЛД гарахыг эхэлж сонго",
        text:
          "«ӨЭА/наряд ажил» сонголт нь наряд №, цех · хэсэг, төлөв, " +
          "эрэмбэ, ажлын агуулга, 📍байршил, хугацааг ХОЁР МӨРӨӨР " +
          "харуулна. Наряд №, цех, хэсэг, байршил, ажлын нэрийн аль " +
          "нэгээр нь бичээд хайж болно.",
      },
      {
        title: "Ажилтан нэмэх",
        text:
          "ТН-ээр хайж нэмнэ. Хаашаа, ямар ажлаар гарахыг тодорхой бичнэ.",
      },
      {
        title: "Бөглөлтийг хянах",
        text:
          "KPI карт нь хэдэн хүн 15 асуумжаа бөглөснийг харуулна. " +
          "Бөглөөгүй хүнийг ажилд гаргахгүй.",
      },
    ],
    notes: [
      "Энд бүртгэгдсэн ажилтан системд орох үед 15 асуумжийн урьдчилсан " +
        "шалгалт нь автоматаар гарч ирнэ.",
      "⚠ Ажлын дугаар нь аюул, 15А/5А бөглөлтийг АЖИЛД холбоно. Буруу " +
        "наряд сонгвол тэр ажилтан нөгөө нарядын бригадад орж, §6-д " +
        "буруу газар харагдана.",
      "Нарядын §6 «Бригадын бүрэлдэхүүн» хоосон байвал ЭНЭ хуудсаар " +
        "ажилтан бүртгэгдээгүй гэсэн үг. Тэндээс шууд энэ хуудсыг " +
        "нээх товч бий.",
    ],
  },

  "highrisk/prework15": {
    title: "Урьдчилсан шалгалт — 15 асуумж (ӨЭА)",
    intro:
      "Өндөр эрсдэлт ажилд гарахын өмнө ажилтан өөрөө бөглөх чухал " +
      "хяналтын 15 асуумж.",
    steps: [
      {
        title: "Асуултын утгыг зөв ойлго",
        text:
          "Асуумж «Энэ аюул БАЙНА уу?» гэж асууна. Тиймээс — " +
          "Тийм = АЮУЛ БАЙНА · Үгүй = аюулгүй · Хамаарахгүй = алгасах.",
      },
      {
        title: "Аюул илэрвэл бүртгэ",
        text:
          "«Тийм» сонговол ажил зогсоох цонх нээгдэж, аюулыг тэр дор нь " +
          "бүртгэнэ. Бүртгэсний дараа үлдсэн асуумжаа үргэлжлүүлнэ.",
      },
      {
        title: "Илгээ",
        text:
          "Бүх асуумжид хариулсны дараа илгээх товч идэвхэжнэ. Аюул " +
          "илэрсэн ч илгээнэ — шийдвэрийг удирдах ажилтан гаргана.",
      },
    ],
    notes: [
      "⚠ Аюул илэрсэн үед ЭХЛЭЭД ажлаа зогсоо. Асуумжаа дараа бөглөж " +
        "болно, амь нас дараа засагдахгүй.",
      "Бөглөсөн хариулт нь «Ажилд гаргах зөвшөөрөл» хуудсанд очно.",
    ],
    rule: "Урьдчилсан шалгалтын дүрэм · ӨЭА → 15 асуумж",
  },

  "highrisk/prework5a": {
    title: "Урьдчилсан шалгалт — 5А дадал (ажлын даалгавар)",
    intro:
      "Ажлын даалгавраар ажилд гарах ажилтны 5А дадлын богино шалгалт.",
    steps: [
      {
        title: "Асуултын утгыг зөв ойлго",
        text:
          "5А-гийн асуумж нь ЭЕРЭГ томьёололтой («…аюулгүй юу?»). " +
          "Тиймээс «Үгүй» = шаардлага ХАНГААГҮЙ.",
      },
      {
        title: "№1 «Аюулыг таних» онцгой",
        text:
          "Энд «Үгүй» гэвэл аюул илэрсэнд тооцогдож, ажлын байрны " +
          "үнэлгээний цонх нээгдэнэ.",
      },
      {
        title: "Илгээ",
        text:
          "Илгээсний дараа наряд өгсөн мастер/механик таныг ажилд " +
          "гаргах эсэхийг шийднэ.",
      },
    ],
    notes: [
      "⚠ ӨЭА нарядтай ажилтан 5А-аас гадна 15 асуумжийг ДАВХАР бөглөнө.",
    ],
    rule: "Урьдчилсан шалгалтын дүрэм · ажлын даалгавар → 5А",
  },

  "highrisk/workapproval": {
    title: "Ажилд гаргах зөвшөөрөл",
    intro:
      "Анхан шатны удирдах ажилтан (мастер/механик) урьдчилсан шалгалтын " +
      "хариултыг хараад ажилтныг ажилд гаргах эсэхийг шийдэх хуудас.",
    steps: [
      {
        title: "Шийдвэр хүлээж буйг хараарай",
        text:
          "Шалгалтаа илгээсэн ажилтан «Шийдвэр хүлээж буй» төлөвөөр энд " +
          "гарна — «Үгүй» хариулт байсан ч автоматаар татгалзахгүй.",
      },
      {
        title: "Хариултыг нээж унш",
        text:
          "Мөрийг дэлгэж бүх асуумжийн хариултыг харна. Шаардлага " +
          "хангаагүй мөрүүд тодруулагдсан байна.",
      },
      {
        title: "Шийд",
        text:
          "Ажилд гаргах — ажил эхэлнэ. Татгалзах — шалтгаан, авах арга " +
          "хэмжээг тэмдэглэлдээ бичнэ.",
      },
    ],
    notes: [
      "⚠ Шаардлага хангаагүй байхад ажилд гаргасан бол хариуцлагыг " +
        "шийдвэр гаргасан хүн хүлээнэ.",
    ],
  },

  "highrisk/report": {
    title: "ӨЭА нарядын тайлан",
    intro:
      "Гүйцэтгэсэн наряд, өдрийн наряд гэсэн хоёр тайланг гаргаж хэвлэх " +
      "хуудас.",
    steps: [
      {
        title: "Тайлангаа сонго",
        text:
          "«Гүйцэтгэсэн ажил» — сонгосон хугацааны нэгтгэл, нэгжээр " +
          "бүлэглэсэн. «Өдрийн наряд» — тухайн өдөр идэвхтэй байсан наряд, " +
          "ээлжийн хуваарилалттай.",
      },
      {
        title: "Хугацаа, нэгжээ заа",
        text:
          "Таны эрхийн хүрээнд байгаа нэгж л сонголтод гарна — тайлан " +
          "хоосон гарвал эхлээд эрхээ шалгаарай.",
      },
      {
        title: "Хэвлэ",
        text:
          "Хэвлэх товч браузерын хэвлэлтийг нээнэ (Ctrl+P). PDF болгохыг " +
          "хүсвэл хэвлэгчээс «Save as PDF» сонгоно.",
      },
    ],
    notes: [
      "Хуучин HRT системийн RDLC тайлангийн орлуулга — тоо зөрж байвал " +
        "хугацааны хязгаараа шалгана уу.",
    ],
  },

  "highrisk/reference": {
    title: "ӨЭА нарядын лавлах сан",
    intro:
      "Тоног төхөөрөмж, технологийн карт, ХАБЭА-гийн зааврын жагсаалт " +
      "болон тэдгээрийн хоорондын холбоосыг удирдана.",
    steps: [
      {
        title: "Ангиллаа сонго",
        text:
          "Таб бүр өөр лавлах — техник, заавар, ажлын төрөл, нэгж г.м.",
      },
      {
        title: "Холбоосыг шалга",
        text:
          "Тоног төхөөрөмж бүрд ЯМАР технологийн карт, заавар " +
          "харгалзахыг энд тогтооно. Наряд бүртгэхэд яг энэ холбоосоор " +
          "автоматаар санал болгоно.",
      },
      {
        title: "Нэмэх / засах",
        text:
          "Лавлахын эзэн нь ЭНЭ систем — хуучин HRT дээр цаашид " +
          "засагдахгүй. Шинэ мөрөө энд нэмнэ.",
      },
          {
        title: "Объектын ангилал",
        text:
          "Зорилтот хяналтад хамрагдах 14 объект / ажлын төрөл. Журмын " +
          "мөрүүд цоожтой — устгагдахгүй, зөвхөн идэвхгүй болно.",
      },
      {
        title: "Өдөр тутмын асуумж",
        text:
          "АШУА-гийн 14 асуумжийг удирдана. Хамгийн чухал нь «эх " +
          "сурвалжийн горим» — тухайн тоо манай баазаас гарах эсэх.",
      },
      {
        title: "Гэрээт байгууллагын АЖИЛЧИД",
        text:
          "«Гэрээт байгууллага» табад байгууллагын мөрийг ДЭЛГЭХЭД " +
          "түүний ажилчид гарна. Энд бүртгэсэн хүн наряд бүртгэх §4-т " +
          "«байгууллагаа сонго → ажилтнаа сонго» болж гарч ирнэ. " +
          "Регистр нь нэг байгууллагын дотор давхардахгүй.",
      },
      {
        title: "Плакат / пайз",
        text:
          "«Урьдчилан сэргийлэх арга хэмжээ (§7)» табын доор «Бүү залга», " +
          "«Газардуулсан», «Цоож», «Энд ажиллаж болно» зэрэг ажлын " +
          "байранд зүүдэг тэмдэглэгээг удирдана.",
      },
],
    notes: [
      "⚠ Ашиглагдаж байгаа мөрийг устгавал хуучин нарядууд нэргүй болно. " +
        "Устгахын оронд идэвхгүй болгоно уу.",
          "«Автомат» гэж тэмдэглэсэн үзүүлэлтийг АШУА бөглөхгүй — манай " +
        "бүртгэлээс тооцогдоно. «Гараар» гэснийг л оруулна.",
      "Гэрээт ажилтныг лавлахаас ХАСАХАД хуучин наряд дээр бичигдсэн нэр " +
        "ХЭВЭЭР үлдэнэ — хэвлэлт өөрчлөгдөхгүй. Наряд бол хуулийн баримт " +
        "тул тухайн үеийн байдлаараа хадгалагдана.",
      "Байнга ажилладаг гэрээт хүнийг ЭНД нэг удаа бүртгэвэл наряд бүрд " +
        "дахин бичих шаардлагагүй. Гараар бичих нь нэг хүнийг «Батбаяр», " +
        "«Б.Батбаяр» гэх мэт олон хэлбэрээр үүсгэдэг.",
],
  },

  // ── Хяналт шалгалт (FR-02) ───────────────────────────────────────────
  // /inspection/register нь ЖАГСААЛТ — INSPECTION_LIST-ийг хуваалцна
  "inspection/register": INSPECTION_LIST,
  /* ХУУЧИН МАЯГТ — /inspection/register/20 (routers/inspection.js).
     ⚠ ЯГ ТААРСАН зам нь түлхүүр: `helpFor` дээшээ унахаасаа ӨМНӨ яг
       таарсныг шалгадаг тул энэ нь `inspection/register`-ийг дарж,
       ЗӨВХӨН тэр хуучин хуудсанд гарна. */
  "inspection/register/20": {
    title: "Хяналт шалгалт бүртгэх (хуучин маягт)",
    intro:
      "Хяналт шалгалтыг шатаар нь бүртгэх хуучин маягт. Шинэ шалгалтыг " +
      "«Хяналт шалгалт» жагсаалтаас эхлүүлнэ.",
    steps: [
      {
        title: "Шатаа сонго",
        text:
          "I — ээлжийн, II — хэсгийн, III — бүтцийн нэгжийн, IV — ХАБЭА " +
          "хэлтсийн шалгалт. Танд эрх байгаа шат л сонголтод гарна.",
      },
      {
        title: "Шалгах хуудсаа бөглө",
        text:
          "Журмын стандарт үзүүлэлт дээр нэгжийн нэмэлт мөрүүд нэмэгдэнэ. " +
          "Мөр бүрд хангасан / хангаагүй гэж тэмдэглэнэ.",
      },
      {
        title: "Зөрчлөө бүртгэ",
        text:
          "«Хангаагүй» мөр бүр зөрчил болж бүртгэгдэнэ — зураг, " +
          "хариуцах эзэн, арилгах хугацааг заавал оруулна.",
      },
    ],
    notes: [
      "Хугацаагүй зөрчил хэзээ ч арилдаггүй — хугацааг ҮРГЭЛЖ бич.",
    ],
    rule: "ХЭМАБМТ-06 · хяналт шалгалтын журам",
  },

  "inspection/list": INSPECTION_LIST,
  // /inspection/xab — жагсаалтын хуучин каноник хаяг, ижил хуудас
  "inspection/xab": INSPECTION_LIST,

  /* ХЯНАЛТ ШАЛГАЛТ БӨГЛӨХ (бүртгэх) — components/inspection/
     InspectionChecklistForm.js. Энэ нь /inspection/xab/:id зам, мөн
     жагсаалт болон бусад хуудсаас модал дотор дуудагддаг тул түлхүүрээ
     ИЛ авна (`topic="inspection/fill"`), замаас биш. */
  "inspection/fill": {
    title: "Хяналт шалгалт бүртгэх",
    intro:
      "Батлагдсан шалгах хуудсаар хяналт шалгалт явуулж, илэрсэн зөрчлийг " +
      "хариуцагч, хугацаатайгаар бүртгэх хуудас.",
    /* ⚠ ЭХЛҮҮЛСНИЙ ДАРААХ урсгал (2026-10-14-нд дахин бичсэн).
       Өмнө нь шат сонгох · хуудас сонгох · нэгж заах гэсэн
       ЭХЛҮҮЛЭХЭЭС ӨМНӨХ алхмууд байсан — тэдгээр нь «Шалгалт
       эхлүүлэх» модал дээр хийгддэг, энэ хуудсанд БИШ.
       Алхам бүр кодоос баталгаажсан, зохиосон зүйл алга. */
    steps: [
      {
        title: "① Шалгах хуудас өөрөө бэлдэнэ",
        text:
          "«Эхлүүлэх» дарсны дараа журмын СТАНДАРТ үзүүлэлт дээр тухайн " +
          "нэгжийн БАТЛАГДСАН нэмэлт мөрүүд нэмэгдэж, нэгжид " +
          "хамааралгүй гэж хассан мөрүүд хасагдаж хуудас бүрдэнэ. " +
          "Мөр нэмэх, хасах нь «Шалгах хуудасны лавлах» дээр хийгддэг.",
      },
      {
        title: "② Мөр бүрийг тэмдэглэ",
        text:
          "Үзүүлэлт бүрд хангасан / хангаагүй гэж тэмдэглэнэ. Бөглөөгүй " +
          "мөр үлдвэл дээд талд «N бөглөөгүй» гэж шар өнгөөр сануулна.",
      },
      {
        title: "③ Хангаагүй мөрд зөрчлөө бүртгэ — 4 талбар ЗААВАЛ",
        text:
          "Зөрчлийн тайлбар · арилгах ХУГАЦАА · ХАРИУЦАГЧ · зөрчлийн " +
          "АНГИЛАЛ. Аль нэг нь дутуу бол мөр «Ноорог (дутуу)» төлөвт " +
          "хадгалагдана — ажил алга болохгүй, гэхдээ ийм мөр үлдсэн " +
          "цагт шалгалт ХААГДАХГҮЙ. Хариуцагчийг нэр эсвэл ТН-ээр " +
          "хайж сонгоно. Зураг хавсаргавал дараагийн шалгалтад " +
          "«арилсан эсэх»-ийг нотлох баримт болно.",
      },
      {
        title: "④ Явцдаа ХАДГАЛАХ дар",
        text:
          "⚠ Бөглөсөн бүхэн «Хадгалах» дарах хүртэл ЗӨВХӨН хөтөч дээр " +
          "байдаг — таб хаах, F5 дарах, сесс тасрахад бүгд алга болно. " +
          "20-30 үзүүлэлт бөглөхдөө завсар завсарт хадгалж бай. " +
          "Хадгалах нь шалгалтыг ХААХГҮЙ, дараа үргэлжлүүлж болно.",
      },
      {
        title: "⑤ Зөрчлийн биелэлтийг хүлээн ав",
        text:
          "Хариуцагч биелэлтээ илгээхэд зөрчил «Баталгаажуулах хүлээж " +
          "буй» болно. Шалгагч зөрчлийн дэлгэрэнгүй дээр «Хүлээн авах» " +
          "эсвэл «Буцаах» дарна. Хүлээн авсан зөрчил Л арилсанд тооцогдоно.",
      },
      {
        title: "⑥ Дүгнэж хаах",
        text:
          "Бүх мөр бөглөгдөж, зөрчил бүр арилсны дараа «Дүгнэж хаах». " +
          "Арилгаагүй зөрчил үлдвэл хаалт ЗОГСОНО — аль зөрчил саад " +
          "болж байгааг жагсаалтаар харуулж, тус бүр рүү нь шилжих " +
          "холбоос өгнө. Оноо, үнэлгээ автоматаар бодогдоно.",
      },
      {
        title: "⑦ III ба IV шат — дүнгийн хурлаар",
        text:
          "Эдгээр шатыг шалгагч дангаараа хаахгүй: «Дүнгийн хуралд " +
          "илгээх» → комиссын удирдагч «Хурлаар батлах» дарж байж " +
          "хаагдана. Хаалтын хурлаас 5 цагийн өмнө илгээнэ " +
          "(журам 4.1.4.3). Комисстой шалгалтад гишүүн бус хүн " +
          "илгээх, хаах товчийг дарж чадахгүй.",
      },
      {
        title: "⑧ Албан шаардлага",
        text:
          "III, IV шат ба ээлжит бус хяналтын зөрчил АЛБАН ШААРДЛАГА " +
          "болж гарна (журам 2.5.5-2.5.6). Үүссэн баримтыг хуудас дээр " +
          "мэдэгдэнэ — дахин үүсгэх шаардлагагүй.",
      },
      {
        title: "⑨ Буруу хаасан бол нээх",
        text:
          "I, II, III шат ба бусад хяналтыг ОРУУЛСАН хүн өөрөө буцааж " +
          "нээнэ. IV шатыг зөвхөн ХАБЭА хэлтэс нээнэ. Нээхдээ ШАЛТГААН " +
          "заавал бичнэ — аудитад үлдэнэ. Нээхэд өмнөх үнэлгээ " +
          "цэвэрлэгдэж, дахин дүгнэнэ.",
      },
    ],
    notes: [
      "«Хадгалах» дарахгүй бол бөглөсөн зүйл серверт ОЧИХГҮЙ — таб хаахад алга болно.",
      "Зөрчлийн 4 талбарын аль нэг дутуу бол мөр «Ноорог» болж, шалгалт хаагдахгүй.",
      "Хугацаагүй зөрчил хэзээ ч арилдаггүй — хугацааг ҮРГЭЛЖ бич.",
      "Өөрийн бус бүтцийн нэгжийн шалгалтыг засах эрх байхгүй — засах товч харагдахгүй.",
      "Зөрчилтэй мөрийн зураг нь дараагийн шалгалтад «арилсан эсэх»-ийг баталгаажуулах баримт болно.",
    ],
    rule: "ХЭМАБМТ-06 · хяналт шалгалтын журам, Хавсралт №2-6",
  },

  // Зөрчлийн төрлийн хяналт — /inspection/types (2026-09-23)
  "inspection/types": {
    title: "Зөрчлийн төрлийн хяналт",
    intro:
      "Бүх шатны хяналт шалгалтаар илэрсэн зөрчлийг нэг жагсаалтад гаргаж, " +
      "төрлөөр нь (механик, цахилгаан, технологи) шүүж хянах хуудас.",
    steps: [
      {
        title: "Төрлөөр нь шүүх",
        text:
          "Дээд талын өнгөт карт дээр дарж тухайн төрлийн зөрчлийг л " +
          "шүүнэ. Дахин дарвал шүүлт арилна. ХЭМАБМТ-06 2.5.5-д заасны " +
          "дагуу II шатны зөрчлийг төрлөөр нь хариуцуулна.",
      },
      {
        title: "Хариуцуулах",
        text:
          "Мөрийн «хүн нэмэх» товчоор зөрчлийн төрөл, хариуцагч, арилгах " +
          "хугацааг ононо. Хадгалахад тухайн хүний «Миний даалгавар» " +
          "жагсаалтад орж, биелэлтээ баримттай илгээнэ.",
      },
      {
        title: "Биелэлт баталгаажуулах",
        text:
          "«Биелэлт ирсэн» төлөвтэй мөрийг шалгагч эсвэл ХАБЭА хэлтэс " +
          "хүлээн авна. Хариуцагч ӨӨРИЙНХӨӨ биелэлтийг баталгаажуулж " +
          "болохгүй — товч нь харагдахгүй.",
      },
      {
        title: "Онцлох шүүлт",
        text:
          "«Хугацаа хэтэрсэн», «Ноцтой зөрчил», «Хуваарилаагүй» гэсэн " +
          "шүүлтээр анхаарал шаардсан зөрчлийг шууд ялгаж харна.",
      },
    ],
  },
  "inspection/requirements": {
    title: "Албан шаардлага / АКТ",
    intro:
      "Шалгалтын үр дүнгээр гарсан албан шаардлагыг гаргаж, биелэлтийг " +
      "хянах хуудас.",
    steps: [
      {
        title: "Гаралтын төрлийг мэд",
        text:
          "III шат → Албан шаардлага. IV шат → албан шаардлага + дүнгийн " +
          "хурал. Ээлжит бус → АКТ-албан шаардлага.",
      },
      {
        title: "Агуулгыг шалга",
        text:
          "Зөрчигдсөн журам/дүрэм/зааврын нэр, арилгах хугацаа заавал " +
          "тусгагдсан байх ёстой.",
      },
      {
        title: "Гарын үсэг ба биелэлт",
        text:
          "БН-ийн удирдлага, шалгуулсан хэсгийн дарга гарын үсэг зурна. " +
          "Арилгасны дараа тэмдэглэл хийж хаана.",
      },
    ],
    notes: [
      "Албан шаардлага нь шалгалтын зөрчлөөс АВТОМАТААР үүснэ — энд " +
        "голчлон биелэлтийг хянана.",
    ],
    rule: "ХЭМАБМТ-06 · 2.5.5 – 2.5.6",
  },

  // ── Зөрчил ба төлөвлөгөө ─────────────────────────────────────────────
  "incident/register": {
    title: "Зөрчлийн бүртгэл",
    intro:
      "Хяналт шалгалтын явцад илэрсэн зөрчлийг бүртгэж, шийдвэрлэлтийг " +
      "нь дуустал хянах хуудас.",
    steps: [
      {
        title: "Тоон үзүүлэлтээ унш",
        text:
          "Нийт / шинэ / шийдвэрлэгдээгүй / шийдвэрлэгдсэн. Карт дээр " +
          "дарж тухайн төлөвөөр шүүнэ.",
      },
      {
        title: "Шинэ зөрчил бүртгэх",
        text:
          "Товч дархад маягт нээгдэнэ. Таны эрхээс хамаарч аль шатны " +
          "зөрчил бүртгэхийг систем өөрөө тогтооно.",
      },
      {
        title: "Гүйцэтгэлээ ХУВИАР бүртгэ",
        text:
          "Зөрчил дээр дарж дэлгэрэнгүйд орно. «Гүйцэтгэл бүртгэх» " +
          "дээр юу хийснээ бичээд явцаа 0–100%-иар тэмдэглэнэ. Дахин " +
          "ажилласан бол ШИНЭ бичилт нэмнэ — өмнөх бичилт хэвээр " +
          "үлдэж, бүх ажлын түүх харагдана.",
      },
      {
        title: "Хянаж баталгаажуул",
        text:
          "Гүйцэтгэл бичигдсэний дараа хянагч «Хянасан» эсвэл «Дахин " +
          "гүйцэтгэх» гэж шийднэ. Буцаахдаа ЮУ ДУТУУ байгааг тодорхой " +
          "бичнэ — гүйцэтгэгч юуг засахаа мэдэх ёстой.",
      },
      {
        title: "Шийдвэрлэлтийг хаах",
        text:
          "Арга хэмжээ хэрэгжсэний дараа баримт хавсаргаж хаана. " +
          "Баримтгүй хаагдсан зөрчил дахин давтагдана.",
      },
    ],
    notes: [
      "Зөрчил бүрд ХАРИУЦАХ ЭЗЭН ба ХУГАЦАА байх ёстой — эзэнгүй зөрчил " +
        "хэн ч арилгахгүй.",
      "⚠ ГҮЙЦЭТГЭЛГҮЙ зөрчлийг ХЯНАХ БОЛОМЖГҮЙ. Эс бөгөөс юу ч " +
        "хийгдээгүй зөрчил «хянагдсан» болж хаагдаад чимээгүй алга " +
        "болно. Тиймээс эхлээд гүйцэтгэгч ажлаа бүртгэнэ.",
      "⚠ Хувь нь ЗӨВХӨН СҮҮЛИЙН гүйцэтгэлээс тооцогдоно. 100% болсон " +
        "ажил буцаагдаад 40% гэж дахин бичигдвэл жагсаалтад 40% " +
        "харагдана — «дахин гүйцэтгэ» гэсэн шийдвэр утгатай байх ёстой.",
      "100% гэдэг нь «дууссан» БИШ — «хяналт хүлээж буй». Хянагч " +
        "баталгаажуулж байж «Хянагдсан» болно.",
      "Зөвхөн ӨӨРИЙН бичилтийг устгана. Гүйцэтгэлийн бүртгэл бол " +
        "баримт — бусдын бичилтийг арилгах боломжгүй.",
      "Жагсаалтын «Гүйцэтгэл» багана «—» гэж харагдвал энэ нь «0%» " +
        "гэсэн үг БИШ — гүйцэтгэлийн хүснэгт бэлэн болоогүй байна.",
    ],
  },

  // Зөрчлийн төрлийн хяналт — /incident/type (2026-09-23)
  "incident/type": {
    title: "Зөрчлийн төрлийн хяналт",
    intro:
      "Бүртгэгдсэн зөрчлийг (ZR-) төрлөөр нь шүүж, авсан арга хэмжээ, " +
      "хариуцагч, хугацаа, гүйцэтгэлийн явцыг хянах хуудас.",
    steps: [
      {
        title: "Төрлөөр нь шүүх",
        text:
          "Дээд талын өнгөт карт дээр дарж тухайн төрлийн зөрчлийг л " +
          "шүүнэ. Нэг зөрчил 2-3 төрөлтэй байж болох тул картын нийлбэр " +
          "нь нийт бүртгэлээс их гарч болно.",
      },
      {
        title: "Юуг хянах вэ",
        text:
          "Мөр бүрд: авсан арга хэмжээ, хэнд хуваарилсан, хугацаа, " +
          "гүйцэтгэлийн хувь ба сүүлийн бичилт харагдана. «Хуваарилаагүй», " +
          "«Хугацаа хэтэрсэн» шүүлтээр анхаарал шаардсаныг ялгана.",
      },
      {
        title: "Засах",
        text:
          "Дугаар эсвэл харандаа дээр дарж зөрчлийн дэлгэрэнгүй хуудас руу " +
          "очно. Энэ хуудас нь ЗӨВХӨН хяналт — засварыг бүртгэлийн маягтаар " +
          "хийнэ.",
      },
      {
        title: "Хамрах хүрээ",
        text:
          "Зөрчлийн жагсаалттай ижил дүрмээр — өөрийн цех, хэсэг эсвэл " +
          "өөрийн бүртгэл. ХАБЭА хэлтэс бүгдийг харна.",
      },
    ],
  },
  "incident/reference": {
    title: "Хяналт шалгалтын лавлах",
    intro:
      "Шалгалтын төрөл, шат, шалгах хуудасны үзүүлэлтийг удирдана.",
    steps: [
      {
        title: "«Төрөл ба шат»",
        text:
          "Зөрчил бүртгэх маягт яг эндээс уншина — энд өөрчилсөн зүйл " +
          "маягтад шууд тусна.",
      },
      {
        title: "«Шалгах хуудасны үзүүлэлт»",
        text:
          "Журмын стандарт мөрүүд дээр бүтцийн нэгж өөрийн нэмэлтээ " +
          "оруулна. Цехийн ХАБ инженер нэмж, цехийн дарга батална.",
      },
    ],
    notes: [
      "⚠ Ашиглагдаж байгаа үзүүлэлтийг устгавал хуучин шалгалтууд " +
        "нэргүй болно — идэвхгүй болгоно уу.",
    ],
  },

  "plan/register": {
    title: "Арга хэмжээний төлөвлөгөө бүртгэх",
    intro:
      "Зөрчил, эрсдэлээс үүдэн авах арга хэмжээг хугацаа, хариуцагчтай " +
      "нь төлөвлөх хуудас.",
    steps: [
      {
        title: "Юунаас үүдсэнийг холбо",
        text:
          "Арга хэмжээ нь тодорхой зөрчил эсвэл эрсдэлтэй холбогдсон " +
          "байх ёстой — эс бөгөөс биелэлт нь юуг шийдсэн нь мэдэгдэхгүй.",
      },
      {
        title: "Хэн, хэзээ, ямар нөөцөөр",
        text:
          "Гурвуулаа заавал. Нөөц (мөнгө, хүн, материал) тодорхойгүй " +
          "төлөвлөгөө хэрэгждэггүй.",
      },
    ],
  },

  "plan/list": {
    title: "Төлөвлөгөөний биелэлт",
    intro:
      "Батлагдсан арга хэмжээний хэрэгжилтийг хугацаа, хариуцагчаар " +
      "хянах хуудас.",
    steps: [
      {
        title: "Хугацаа хэтэрсэнийг эхлээд хараарай",
        text: "Улаанаар тэмдэглэгдсэн мөр нь хугацаа хэтэрсэн арга хэмжээ.",
      },
      {
        title: "Биелэлт баталгаажуул",
        text: "Хэрэгжсэн ажлыг зураг, акт хавсаргаж хаана.",
      },
    ],
  },

  // ── ХАБ-н минут ─────────────────────────────────────────────────────
  "morningxab/register": {
    title: "ХАБ-н минут — бүртгэл",
    intro:
      "Ажил эхлэхийн ӨМНӨ хэсгээрээ хийсэн ХАБ / эрүүл мэндийн 5-10 " +
      "минутын мэдээллийн уулзалтаа энд бүртгэнэ: хэн · хэзээ · ямар " +
      "сэдвээр · хаана · хэдэн хүнтэй, ЗУРАГ/БИЧЛЭГ баримттай. Бүртгэл " +
      "ХАБЭА хэлтэст илгээгдэж, тэндээс хүлээн авагдана.",
    steps: [
      {
        title: "«Шинэ бүртгэл» дар",
        text:
          "Хуудасны дээд хэсгийн товчоор шинэ маягт нээгдэнэ. Хэрэв товч " +
          "харагдахгүй бол танд бүртгэх эрх байхгүй — доорх «Хэн юу хийх " +
          "вэ» хэсгийг хар.",
      },
      {
        title: "Огноо, цаг, үргэлжилсэн хугацаа",
        text:
          "«Огноо» ЗААВАЛ. «Эхэлсэн цаг» (жишээ: 08:00) ба «Үргэлжилсэн " +
          "(мин)» нь хэдэн минут ярьсныг харуулна — 5-10 минут нь хэвийн. " +
          "Огноог хойшлуулж бүртгэж болно, гэхдээ уулзалт хийсэн ӨДРӨӨР нь " +
          "бичнэ.",
      },
      {
        title: "Сэдвээ сонго",
        text:
          "«Сэдэв» ЗААВАЛ — лавлахаас сонгоно (/knowledge/reference дээр " +
          "ХАБЭА хэлтэс удирддаг). Жагсаалтад байхгүй сэдэв бол хамгийн " +
          "тохирохыг сонгоод «Юу ярьсан талаар» гэсэн хэсэгт дэлгэрэнгүй " +
          "бичнэ.",
      },
      {
        title: "Товч гарчиг ба хэлэлцсэн зүйл",
        text:
          "«Товч гарчиг» нь жагсаалтад харагдах нэр (жишээ: «Гар багажны " +
          "аюулгүй хэрэглээ»). «Юу ярьсан талаар» гэсэн хэсэгт гол " +
          "зүйлсийг бичнэ — дараа нь хяналтад ХАМГИЙН их уншигддаг хэсэг " +
          "нь энэ.",
      },
      {
        title: "Байршил ба оролцогчид",
        text:
          "«Байршил (өрөө / хэсэг)» — хаана хийсэн (жишээ: «2-р ээлжийн " +
          "өрөө»). Оролцогчийг ХОЁР аргаар нэмнэ: цех/хэсгээ сонгоод " +
          "ажилтны жагсаалтаас, эсвэл Б/Д (табелийн дугаар)-аар нэг " +
          "бүрчлэн. Нэмсэн тоо нь «Оролцогчийн тоо»-г өөрөө бөглөнө.",
      },
      {
        title: "Баримт хавсарга — ЗААВАЛ",
        text:
          "Зураг, богино бичлэг эсвэл PDF-ээ хавсаргана. Хавсралтгүйгээр " +
          "хадгалах товч ажиллахгүй: «Уулзалтын зураг, бичлэг эсвэл " +
          "PDF-ээ хавсаргана уу» гэсэн анхааруулга гарна. Хавсралтыг " +
          "жагсаалтаас icon-оор харж, томруулж, татаж авч болно.",
      },
      {
        title: "Хадгалаад төлвийг хяна",
        text:
          "Хадгалмагц бүртгэл «Хянагдаж буй» болно. ХАБЭА хэлтэс хүлээн " +
          "авбал «Хүлээн авсан» болж ЦААШИД ЗАСАГДАХГҮЙ. Буцаавал " +
          "тайлбартай нь ирэх тул засаад дахин илгээнэ.",
      },
    ],
    roles: [
      {
        role: "Хэсгийн дарга · мастер",
        text:
          "Уулзалтаа хийж, тэр өдөртөө бүртгэнэ. Баримтаа зайлшгүй " +
          "хавсаргана. Өөрийн бүртгэсэн мөрийг л засаж, устгаж чадна.",
      },
      {
        role: "БН-ийн ХАБ ажилтан",
        text:
          "Өөрийн БН-ийн бүх бүртгэлийг хараад, дутуу хэсгүүдийг " +
          "сануулна. Шаардлагатай бол өөрөө ч бүртгэж болно.",
      },
      {
        role: "БН-ийн удирдлага",
        text:
          "Өөрийн БН-ийн хамрах хүрээг хянана: хэдэн хэсэг бүртгэсэн, " +
          "хэд нь хоцорсон. Хяналтын хэсгийн тоонууд шүүлтээс хамаарна.",
      },
      {
        role: "ХАБЭА хэлтэс",
        text:
          "Бүх БН-ийг хараад бүртгэлийг ХҮЛЭЭН АВНА эсвэл тайлбартай " +
          "БУЦААНА. Хяналтын самбар нь /morningxab/dashboard.",
      },
    ],
    notes: [
      "«Хүлээн авсан» бүртгэлийг засах, устгах БОЛОМЖГҮЙ. Шаардлагатай " +
        "бол ХАБЭА хэлтэс эхлээд буцаана.",
      "Өөрийн бүртгээгүй мөрийг засах, устгах боломжгүй — ХАБЭА хэлтэс ч мөн.",
      "ХАБЭА хэлтэс биш хэрэглэгч ЗӨВХӨН өөрийн БН-ийн бүртгэлийг харна.",
      "Хяналтын хэсгийн тоо (Нийт бүртгэл · Хянагдаж буй · Хүлээн авсан) " +
        "нь шүүлтээс ХАМААРНА — шүүлт тавиад тоо өөрчлөгдвөл тэр нь зөв.",
    ],
    rule: "ХЭМАБМТ-06 · ХАБ-н минутын уулзалт",
  },

  "morningxab/dashboard": {
    title: "ХАБ-н минут — хяналтын самбар",
    intro:
      "ХАБЭА хэлтэс БН-үүдээс ирсэн ХАБ-н минутын бүртгэлийг хянаж, " +
      "ХҮЛЭЭН АВАХ эсвэл БУЦААХ шийдвэр гаргах хуудас. Удирдлага нь " +
      "хамрах хүрээг (хэн бүртгэсэн, хэн хоцорсон) эндээс харна.",
    steps: [
      {
        title: "Хамрах хүрээгээ шүүлтээр тогтоо",
        text:
          "Хугацаа, БН, сэдэв, төлөвөөр шүүнэ. Доорх БҮХ тоо, задаргаа, " +
          "жагсаалт нь энэ шүүлтээс хамаарна — тоо өөрчлөгдвөл тэр нь зөв.",
      },
      {
        title: "Хяналтын тоонуудыг унш",
        text:
          "«Нийт бүртгэл» · «Хүлээн авсан» · «Хянагдаж буй» · оролцогчийн " +
          "тоо. «Хянагдаж буй» нь ТАНЫ шийдвэрийг хүлээж байгаа хэмжээ — " +
          "эхлээд түүнийг ав.",
      },
      {
        title: "Задаргаагаар цоорхойг ол",
        text:
          "БН-ээр · Нэгжээр · Сэдвээр · Ангиллаар задарна. Бүртгэл " +
          "ДУТУУ БН нь тоо багатайгаараа эсвэл жагсаалтад огт " +
          "харагдахгүйгээрээ илэрнэ — хамгийн чухал нь тэр.",
      },
      {
        title: "Баримтыг НЭЭЖ хар",
        text:
          "Мөр дээрх зураг/бичлэг/PDF-ийг нээж уулзалт ҮНЭХЭЭР болсон " +
          "эсэхийг шалгана. Баримтыг харалгүй хүлээн авах нь хяналтын " +
          "утгыг нь алдагдуулна.",
      },
      {
        title: "Хүлээн ав эсвэл буцаа",
        text:
          "«Хүлээн авсан» болмогц бүртгэл ХААГДАНА — бүртгэсэн хүн " +
          "цаашид засаж чадахгүй. Дутуу бол ТАЙЛБАР бичиж буцаана: " +
          "тайлбаргүй буцаавал хүн юуг засахаа мэдэхгүй.",
      },
    ],
    roles: [
      {
        role: "ХАБЭА хэлтэс",
        text:
          "Баримтыг нээж шалгаад хүлээн авна эсвэл тайлбартай буцаана. " +
          "Бүх БН-ийг харна.",
      },
      {
        role: "БН-ийн удирдлага",
        text:
          "Өөрийн БН-ийн хамрах хүрээг хянана: аль хэсэг бүртгээгүй, " +
          "ямар сэдэв давамгайлж байна. Шийдвэр гаргах товч гарахгүй.",
      },
      {
        role: "БН-ийн ХАБ ажилтан",
        text:
          "Өөрийн БН-ийн бүртгэлийн төлвийг хянаж, буцаагдсаныг засуулна.",
      },
    ],
    notes: [
      "Хүлээн авах / буцаах эрхийг СЕРВЭР шалгана (ХАБЭА хэлтсийн роль " +
        "эсвэл бүлэг 173/174) — эрхгүй хүнд товч огт гарахгүй.",
      "Буцаасан тайлбар нь бүртгэсэн хүнд харагдана — юуг засахыг " +
        "тодорхой бич.",
      "Бүртгэл ӨӨРӨӨ энд үүсэхгүй: БН-үүд /morningxab/register дээр " +
        "бүртгэнэ.",
    ],
    rule: "ХЭМАБМТ-06 · ХАБ-н минутын уулзалт",
  },

  "knowledge/register": {
    title: "Минутын мэдлэг (М-мэдлэг)",
    intro:
      "7 хоног бүр нэг сэдэв: ажилтан бичлэгийг үзээд ӨДӨРТ 1 асуултад " +
      "хариулна. Нэг хуудас боловч эрхээс хамаарч ТАБ өөр: ажилтанд " +
      "«Өнөөдрийн мэдлэг», ХАБЭА хэлтэст мэдлэгийн сан ба хуваарь.",
    steps: [
      {
        title: "«Өнөөдрийн мэдлэг» табыг нээ",
        text:
          "Тухайн 7 хоногийн сэдвийн бичлэгийг үзнэ. Бичлэгийг үзэлгүйгээр " +
          "асуултад хариулах нь мэдлэг олгох зорилгыг алдагдуулна.",
      },
      {
        title: "Өдрийн 1 асуултад хариул",
        text:
          "Өдөрт ЗӨВХӨН нэг асуулт ирнэ. Хариулсны дараа зөв эсэхийг " +
          "шууд харуулна. Маргааш дараагийн асуулт нээгдэнэ.",
      },
      {
        title: "Биелэлтээ хян",
        text:
          "Өөрийн үзсэн, хариулсан түүхээ /knowledge/my дээр харна. " +
          "Нэгжийн биелэлт нь /knowledge/dashboard.",
      },
    ],
    roles: [
      {
        role: "Ажилтан (хэн ч)",
        text:
          "«Өнөөдрийн мэдлэг» табыг л харна: бичлэг үзэж, өдрийн 1 " +
          "асуултад хариулна.",
      },
      {
        role: "БН-ийн ХАБ ажилтан",
        text:
          "Өөрийн БН-ийн биелэлтийг /knowledge/dashboard дээр хянаж, " +
          "хоцорсон ажилтанд сануулна.",
      },
      {
        role: "ХАБЭА хэлтэс",
        text:
          "«Мэдлэгийн сан» табаар сэдэв, бичлэг, асуулт бүртгэнэ. " +
          "«7 хоногийн хуваарь» табаар аль долоо хоногт аль сэдэв " +
          "явахыг тогтооно.",
      },
    ],
    notes: [
      "Сэдэв, асуулт нэмэх нь ЗӨВХӨН ХАБЭА хэлтэст — бусад хэрэглэгчид " +
        "тэр таб харагдахгүй.",
      "Хуваарьт сэдэв тавиагүй долоо хоногт ажилтанд юу ч гарахгүй — " +
        "хуваарийг урьдчилан бөглөх нь чухал.",
      "Бичлэг нь MinIO-д хадгалагдана; хэмжээ том бол сервер өөрөө " +
        "1080p хэмжээтэй болгож шахна.",
    ],
    rule: "ХЭМАБМТ-04 · мэдлэг олгох процесс",
  },

  "knowledge/dashboard": {
    title: "М-мэдлэг — биелэлтийн хяналт",
    intro:
      "Минутын мэдлэгийн биелэлтийг нэгж, ажилтнаар хянах хуудас: хэн " +
      "бичлэгээ үзсэн, хэн асуултад хариулсан, хэн хоцорсон.",
    steps: [
      {
        title: "Хугацаа, нэгжээ шүү",
        text:
          "7 хоног эсвэл сараар. Доорх бүх тоо шүүлтээс хамаарна.",
      },
      {
        title: "Хамрагдалтын хувийг унш",
        text:
          "Ажилтны тооноос хэд нь хариулсныг хувиар харуулна. Хувь бага " +
          "БН нь бичлэг хүрээгүй эсвэл сануулга байхгүй гэсэн шинж.",
      },
      {
        title: "Хоцорсныг нэрээр ол",
        text:
          "Задаргаанаас нэгж, ажилтны жагсаалт руу орж хэн хариулаагүйг " +
          "нэрээр харна — тэдэнд шууд сануулна.",
      },
    ],
    roles: [
      {
        role: "АШУА · хэсгийн дарга",
        text:
          "Өөрийн хэсгийн ажилтны биелэлтийг хянаж, хоцорсонд сануулна.",
      },
      {
        role: "БН-ийн ХАБ ажилтан · удирдлага",
        text: "Өөрийн БН-ийн хамрагдалтын хувийг хянана.",
      },
      {
        role: "ХАБЭА хэлтэс",
        text:
          "Бүх БН-ийг харьцуулж, хамрагдалт багатай БН-д шаардлага тавина. " +
          "Сэдэв, хуваарийг /knowledge/register дээр удирдана.",
      },
    ],
    notes: [
      "Биелэлт 0 байвал эхлээд ХУВААРЬ шалга: тухайн долоо хоногт сэдэв " +
        "тавиагүй бол ажилтанд асуулт огт гараагүй байна.",
      "Энэ самбар нь зөвхөн харах — сэдэв, асуулт нэмэх нь " +
        "/knowledge/register дээр.",
    ],
    rule: "ХЭМАБМТ-04 · мэдлэг олгох процесс",
  },

  "knowledge/analysis": {
    title: "Минутын мэдлэг — тоон үзүүлэлт",
    intro:
      "Групп, БН, нэгж, сэдвээр задалсан задаргаа болон долоо хоногийн " +
      "чиг хандлага.",
    steps: [
      {
        title: "Задаргааны табаа сонго",
        text: "Сэдвийн бүлгээр · БН-ээр · Нэгжээр · Сэдвээр.",
      },
      {
        title: "Чиг хандлагыг унш",
        text:
          "Долоо хоногийн график буурч байвал агуулга сонирхолгүй " +
          "болсон эсвэл сануулга ажиллахгүй байна гэсэн үг.",
      },
    ],
    notes: [
      "Энэ задаргаа /data-analysis хуудасны «Минутын мэдлэг» табад мөн " +
        "давхар гарна.",
    ],
  },

  "knowledge/reference": {
    title: "Минутын мэдлэгийн лавлах — групп",
    intro:
      "Мэдлэгийн сангийн группуудыг үүсгэж, хэн үзэхийг тодорхойлно.",
    steps: [
      {
        title: "Групп үүсгэ",
        text: "«Эрүүл мэнд», «Өндөрт ажиллах» гэх мэт сэдвийн бүлэг.",
      },
      {
        title: "Хамрах хүрээг заа",
        text:
          "Бүх ажилтан / нэгжээр / албан тушаалаар / ТН-ээр. ⚠ ХААХ нь " +
          "НЭЭХЭЭС ДАВУУ — нэг дүрмээр нээгээд нөгөөгөөр хаавал хаагдана.",
      },
      {
        title: "Долоо хоногийн хуваарь",
        text: "Групп бүрд долоо хоног бүр аль сэдэв нээгдэхийг тохируулна.",
      },
    ],
  },

  "knowledge/regulations": {
    title: "Дүрэм журмын лавлах сан",
    intro:
      "Эрдэнэт үйлдвэрийн ХЭМАБ-ын бүх журам, дүрэм, аргачлал нэг дор. " +
      "Ажилтан хайж нээж уншина; ХАБЭА хэлтэс шинэ журам нэмж, PDF " +
      "хавсаргаж, ЗААЛТ бүрийг бүртгэнэ.",
    steps: [
      {
        title: "Хайж ол",
        text:
          "Нэр, код (ХЭМАБМТ-06 гэх мэт), төрлөөр хайна. Код нь журмын " +
          "бичвэрт өөрөө байдаг тул кодоор хайх нь хамгийн хурдан.",
      },
      {
        title: "Нээж унш",
        text:
          "Мөр дээр дарж PDF-ийг нээнэ. Хавсралт нь MinIO-д хадгалагддаг " +
          "тул интернэтгүй үед нээгдэхгүй байж болно.",
      },
      {
        title: "ХҮЧИНГҮЙ эсэхийг шалга",
        text:
          "«Хүчингүй · огноо» гэсэн тэмдэг бүхий журам нь ШИНЭЧЛЭГДСЭН — " +
          "хажууд нь аль журмаар солигдсоныг заана. Хүчингүй журмаар " +
          "ажиллах нь зөрчил.",
      },
      {
        title: "Заалтыг ашигла",
        text:
          "Заалт бүр тусад нь бүртгэгддэг тул зөрчил бүртгэхэд «аль " +
          "заалтыг зөрчсөн» гэж шууд сонгож болно. «Асуух» хуудас ч " +
          "заалтаас хайдаг.",
      },
    ],
    roles: [
      {
        role: "Ажилтан (хэн ч)",
        text: "Хайж, нээж уншина. Засах эрх шаардлагагүй.",
      },
      {
        role: "АШУА · удирдлага",
        text:
          "Зөрчил бүртгэх, шалгалт хийхдээ заалтыг эндээс хайж " +
          "иш татна.",
      },
      {
        role: "ХАБЭА хэлтэс",
        text:
          "Шинэ журам нэмж, PDF хавсаргаж, заалт бүртгэнэ. Давхардсан " +
          "(шинэчлэгдсэн) журмыг ХААЖ, аль журмаар солигдсоныг заана.",
      },
    ],
    notes: [
      "Журмын жагсаалт, огноо, PDF нь үйлдвэрийн ДҮРЭМ ЖУРМЫН системээс " +
        "(eOffice) шууд уншигдана — энэ сан нь давхарга, эзэн нь тэр систем.",
      "«Нэр давхардсан» гэж харагдвал тэр нь дийлэнхдээ ШИНЭЧЛЭГДСЭН " +
        "хувилбар: хамгийн шинийг үлдээж хуучныг хаана.",
      "Батлагдсан огноо нь зарим зааварт байхгүй — тэр үед нийтэлсэн " +
        "огноо харагдана («нийтэлсэн» гэж тэмдэглэгдэнэ).",
    ],
    rule: "ХЭМАБМТ журмын сан · eOffice эх сурвалж",
  },

  "knowledge/qr-admin": {
    title: "QR цэгийн удирдлага",
    intro:
      "Техник, байршил бүрд QR цэг үүсгэж, наалт хэвлэх хуудас. Ажилтан " +
      "QR уншуулж тухайн техникийн зааврыг шууд авна.",
    steps: [
      {
        title: "Цэг үүсгэ",
        text: "Техник эсвэл байршилдаа холбоно.",
      },
      {
        title: "Наалт хэвлэ",
        text:
          "Наалт нь том QR + техникийн нэр + богино кодтой. QR бохирдож " +
          "элэгдвэл богино кодыг гараар шивж болно.",
      },
      {
        title: "Байршуул",
        text: "Ажилтны нүдний өндөрт, бохирдохгүй, элэгдэхгүй газарт наана.",
      },
    ],
    notes: [
      "Богино код нь андуурагдах тэмдэгтгүй — 0/O, 1/I орохгүй.",
    ],
  },

  "knowledge/my": {
    title: "Миний минутын мэдлэг",
    intro:
      "Өөрийн үзсэн хичээл, бөглөсөн тест, зөв хариултын хувь, Safety " +
      "Point-оо харах хувийн хуудас.",
    steps: [
      {
        title: "Хяналтаа унш",
        text: "Үзсэн, тэнцсэн, авсан оноо — дээд талын картуудад.",
      },
      {
        title: "Түүхээ шүү",
        text: "Хугацаа, групп, төлөвөөр шүүж өдөр бүрийн бичлэгээ харна.",
      },
    ],
    notes: [
      "Хоцорсон хичээлээ нөхөж үзэж болно — гэхдээ оноо буурна.",
    ],
  },

  // ── Дүн шинжилгээ ────────────────────────────────────────────────────
  "data-analysis": {
    title: "Дүн шинжилгээ",
    intro:
      "ХАБЭА-гийн бүх модулийн тоон үзүүлэлтийг нэг дороос харьцуулж " +
      "харах удирдлагын хуудас.",
    steps: [
      {
        title: "Шүүлтээ ӨӨРӨӨ тавь",
        text:
          "Цех, хэсэг, огноо анхнаасаа ХООСОН — санаатай. Урьдчилан " +
          "сонгосон утга нь буруу дүгнэлт төрүүлдэг тул хамрах хүрээгээ " +
          "өөрөө ухамсартай сонгоно.",
      },
      {
        title: "Модулиудыг харьцуул",
        text:
          "Таб бүр өөр модулийн үзүүлэлт — аюул, зөрчил, эрсдэл, " +
          "минутын мэдлэг, ХАБ-н минут.",
      },
      {
        title: "Хандлагыг унш",
        text:
          "Нэг сарын тоо биш, ХАНДЛАГА чухал. Аюулын мэдээлэл буурч, " +
          "зөрчил өсч байвал ажилтан мэдээлэхээ больсон гэсэн үг.",
      },
    ],
    notes: [
      "Таны эрхийн хүрээнд байгаа нэгжийн дата л харагдана — тоо " +
        "зөрөхөд эрхээ эхлээд шалгаарай.",
    ],
  },

  // ── Зааврын удирдлага өөрөө ────────────────────────────────────────
  "help/admin": {
    title: "Зааварчилгааны удирдлага",
    intro:
      "Систем даяарх хуудас бүрийн «?» товчны агуулгыг эндээс засна — " +
      "код өөрчлөх, шинэ хувилбар гаргах шаардлагагүй.",
    steps: [
      {
        title: "Бүлгээ ол",
        text:
          "Заавар нь SSO-гийн ЦЭСЭЭР бүлэглэгдэн нэг хуудсанд дараалж " +
          "харагдана — толгойгоос нь хумина/дэлгэнэ. Дээд талын хайлт нь " +
          "бүх бүлгийг нэгэн зэрэг шүүнэ.",
      },
      {
        title: "Шинэ заавар — цэсээ сонго",
        text:
          "«Нэмэх» дарахад хуудсаа ЦЭСНЭЭС сонгоно. Ингэснээр түлхүүр нь " +
          "цэсний холбоостой яг таарна — гараар бичихэд үсэг зөрвөл заавар " +
          "хэзээ ч гарахгүй. Цэсгүй дэд хуудасны замыг гараар ч бичиж болно.",
      },
      {
        title: "Зааврыг нээ",
        text:
          "«код» шошготой мөр нь кодод бичигдсэн анхдагч. Түүнийг засахын " +
          "тулд эхлээд «Баазад хуулах» дарна — агуулга нь бэлнээр ирнэ.",
      },
      {
        title: "Алхмуудаа бич",
        text:
          "Алхам бүр нэр, тайлбар, дэлгэцийн зурагтай. Дараалал ЧУХАЛ — " +
          "эдгээр нь дарааллаар хийгддэг үйлдэл тул ↑↓-ээр эрэмбэлнэ.",
      },
      {
        title: "ГОЛ зургаа хавсарга",
        text:
          "Хуудсаа бүтнээр нь дэлгэцээс авч, «Хуудасны зураг» дээр " +
          "оруулна. Заавар нээх төдийд хамгийн түрүүнд ЭНЭ гарах тул " +
          "хэрэглэгч уншихаасаа өмнө хуудсаа таньчихна.",
      },
      {
        title: "Зурагтай эсэхийг жагсаалтаас хар",
        text:
          "Жагсаалтын «Зураг» баганад хавсаргасан зураг нь шууд харагдана. " +
          "Саарал icon байвал тухайн заавар зураггүй хэвээр гэсэн үг.",
      },
      {
        title: "Урьдчилан хараад хадгал",
        text:
          "«Урьдчилан харах» дарж хэрэглэгч яг юу харахыг шалгана. Тэр нь " +
          "бодит цонхтой НЭГ кодоор зурагддаг тул зөрөхгүй.",
      },
    ],
    notes: [
      "Хуудасны түлхүүр нь замтай яг таарна — `risk/assessment`. Дэд зам " +
        "дээшээ унана: `risk/reference/factor` дээр `risk/reference`-ийн " +
        "заавар гарна.",
      "Баазад байгаа заавар нь кодын анхдагчаас ДАВУУ. Баазаас устгавал " +
        "кодынх нь дахин гарна.",
      "«Цэсний жагсаалт» таб нь цэс бүр заавартай эсэхийг харуулна — " +
        "зааваргүй үлдсэн хуудсыг эндээс олно.",
      "«Кодчлол ба тэмдэглэгээ» таб нь программ даяар мөрдөх код, өнгө, " +
        "icon-ы лавлах — зөвхөн харна (өмнө нь Checklist лавлах дотор байв).",
      "Зураг нь ХУУДАСНЫ БҮТЦИЙГ харуулах ёстой — жинхэнэ нэр, тоо " +
        "агуулсан дэлгэц бүү тавь. Заавар нь бүх хэрэглэгчид харагдана.",
      "Зөвхөн ХАБЭА хэлтэс засна.",
    ],
  },

  "risk/reference": {
    title: "Эрсдэлийн лавлах сан",
    intro:
      "Үнэлгээнд ашиглагдах аюулын хүчин зүйл, үйл ажиллагаа, систем, " +
      "хяналтын арга хэмжээний жагсаалтыг удирдана.",
    steps: [
      {
        title: "Ангиллаа сонго",
        text: "Зүүн талын табаас ямар лавлах засахаа сонгоно.",
      },
      {
        title: "Нэмэх / засах",
        text:
          "Шинэ мөр нэмэхэд нэр нь ТОДОРХОЙ, давхардаагүй байх ёстой — " +
          "лавлах бол бүх үнэлгээний суурь.",
      },
    ],
    notes: [
      "⚠ Ашиглагдаж байгаа мөрийг устгавал хуучин үнэлгээнүүд нэргүй болно. " +
        "Устгахын оронд идэвхгүй болгох нь зөв.",
    ],
  },
};

/**
 * Жижиг үсгээр индекслэсэн хуулбар.
 *
 * ⚠ Зарим зам ТОМ ҮСЭГТЭЙ (`/highrisk/registerTn`). React Router нь
 *   анхдагчаараа үсгийн том жижгийг ЯЛГАДАГГҮЙ тул хэрэглэгч гараар
 *   `/highrisk/registertn` гэж бичээд ч хуудас нээгдэнэ. Тэр үед заавар
 *   олдохгүй байх нь ойлгомжгүй алдаа болно.
 */
const LOWER = {};
Object.keys(HELP).forEach((k) => (LOWER[k.toLowerCase()] = HELP[k]));

/** Зам эсвэл түлхүүрээр заавар олох. Олдохгүй бол `null`. */
export function helpFor(key) {
  if (!key) return null;
  const k = String(key).replace(/^\/+/, "").replace(/\/+$/, "");
  const hit = (s) => HELP[s] || LOWER[s.toLowerCase()] || null;
  if (hit(k)) return hit(k);
  // `/risk/reference/factor` → `risk/reference` рүү унана
  const parts = k.split("/");
  while (parts.length > 1) {
    parts.pop();
    const up = parts.join("/");
    if (hit(up)) return hit(up);
  }
  return null;
}

export default HELP;
